// import React, { useContext, useEffect, useState } from 'react'
// import AdminContext from '../../StateContext/Application'
// import { apiurl } from '../../../../path'
// import { useLanguage } from '../../../../lang/langcontext/LanguageContext'
// const CreateOutwards = () => {
//     const { language, toggleLanguage, t } = useLanguage();
//     const context = useContext(AdminContext)
//     const { GetProposallist, SecureFileFetching } = context;
//     const [technicalInwards, setTechnicalInwards] = useState([])
//     const [proposallist, setProposalList] = useState([])
//     const [searchTerm, setSearchTerm] = useState('');
//     const budgetEstimation = proposallist;
//     const [filteredBills, setFilteredBills] = useState([]);
//     const [typeofData, settypeofData] = useState("District");
//     const [currentPage, setCurrentPage] = useState(1);

//     const billsPerPage = 10;
//     const [selectedProposal, setSelectedProposal] = useState(null);
//     const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
//     const indexOfLastBill = currentPage * billsPerPage;
//     const indexOfFirstBill = indexOfLastBill - billsPerPage;
//     const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);
//     const headerStyle = {
//         padding: "12px 16px",
//         whiteSpace: "nowrap",
//         borderRight: "1px solid #e0e0e0",
//         textTransform: "capitalize",
//     };

//     const proposalEstimate = async () => {
//         let data = await GetProposallist();
//         const { status, message, Tabletype } = data;
//         if (status) {
//             setProposalList(message)
//             setTechnicalInwards(message);
//             settypeofData(Tabletype);
//         }
//         else {
//             alert(message);
//             setProposalList([]);
//             setTechnicalInwards([]);
//         }
//     };

//     useEffect(() => {
//         proposalEstimate()
//     }, [])

//     useEffect(() => {
//         const lowerSearchTerm = searchTerm.toLowerCase();
//         const filtered = budgetEstimation.filter(bill =>
//             Object.values(bill).some((val) =>
//                 (val || '').toString().toLowerCase().includes(lowerSearchTerm)
//             )
//         );
//         setFilteredBills(filtered);
//     }, [searchTerm, budgetEstimation]);

//     const selectedBillDetails = (BillID) => {
//         const result = budgetEstimation
//             .filter(item => item.ProposalID == BillID)
//             .map(item => ({
//                 "Deputy Engineer": item.Approvance1,
//                 "Department HOD(EE)": item.Approvance2,
//                 "Additional CEO": item.Approvance3,
//                 "RDD Checker (ASO)": item.Approvance4,
//                 "RDD Section Officer": item.Approvance5,
//                 "Deputy Secretary": item.Approvance6,
//             }));

//         setSelectedProposal(result[0]);
//     }

//      return (

//         <>

//             <div className='col-12' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
//                 <div className="col-11 m-auto">
//                     <div className='col-12' >

//                         <div className='col-12 px-4 mb-4 mt-3' style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//                             <h5 className='my-auto fw-bold'>
//                                 <img src="/GR-Approval64.png" alt="Technical Approval" style={{ width: "24px", height: "24px" }} className='my-auto me-1' />
//                                 <span className='my-auto'>{t("Proposal Outwards")}</span>
//                             </h5>
//                             <div style={{ position: "relative", width: "250px", marginRight: "10px" }}>
//                                 <img
//                                     src="/Search32.png"
//                                     alt="Search Icon"
//                                     style={{
//                                         position: "absolute",
//                                         top: "50%",
//                                         left: "10px",
//                                         transform: "translateY(-50%)",
//                                         width: "16px",
//                                         height: "16px",
//                                         opacity: 0.6
//                                     }}
//                                 />
//                                 <input
//                                     type="text"
//                                     placeholder={t("Search")}
//                                     onChange={(e) => setSearchTerm(e.target.value)}
//                                     value={searchTerm}
//                                     style={{
//                                         width: "100%",
//                                         padding: "8px 12px 8px 32px", // left padding makes space for icon
//                                         border: "1px solid #ccc",
//                                         borderRadius: "8px",
//                                         backgroundColor: "#f1f6fc",
//                                         fontSize: "14px",
//                                         color: "#333",
//                                         boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
//                                         outline: "none"
//                                     }}
//                                 />
//                             </div>
//                         </div>

//                         <div className="col-12 pb-5">
//                             <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", maxWidth: "100%", overflowX: "hidden" }}>

//                                 <div className='col-12 tableDesign' style={{ background: '#2C78DB', overflowX: 'scroll' }}>
//                                     {
//                                         typeofData == "District" && (
//                                             <table className='m-0 p-0' style={{ width: '100%', borderCollapse: 'collapse' }}>
//                                                 <thead>
//                                                     <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "18px" }}>
//                                                         <th style={{ padding: "7px 10px", minWidth: "60px" }} rowSpan={2} colSpan={1}>{t("Sr.No")}</th>
//                                                         <th style={{ padding: "7px 10px", minWidth: "250px" }} rowSpan={2} colSpan={1}>{t("Head Code")}</th>
//                                                         <th style={{ padding: "7px 10px", minWidth: "110px" }} rowSpan={2} colSpan={1}>{t("Year")}</th>
//                                                         <th style={{ padding: "7px 10px", minWidth: "230px" }} rowSpan={2} colSpan={1}>{t("Work Name")}</th>
//                                                         <th style={{ padding: "7px 10px", minWidth: "120px" }} rowSpan={2} colSpan={1}>{t("District")}</th>
//                                                         <th style={{ padding: "7px 10px", minWidth: "120px" }} rowSpan={2} colSpan={1}>{t("Taluka")}</th>
//                                                         <th style={{ padding: "7px 10px", minWidth: "200px" }} rowSpan={2} colSpan={1}>{t("Gram Panchayat")}</th>
//                                                         <th style={{ padding: "7px 10px", minWidth: "150px" }} rowSpan={2} colSpan={1}>{t("Constituency Name")}</th>
//                                                         <th style={{ padding: "7px 10px", minWidth: "150px" }} rowSpan={2} colSpan={1}>{t("Proposal File Number")}</th>
//                                                         <th style={{ padding: "7px 10px", minWidth: "130px" }} rowSpan={2} colSpan={1}>{t("Work Amount")}</th>
//                                                         <th style={{ padding: "7px 10px", minWidth: "250px" }} rowSpan={2} colSpan={1}>{t("Proposal Copy")}</th>
//                                                         <th style={{ padding: "7px 10px", minWidth: "250px" }} rowSpan={2} colSpan={1}>{t("Additional Support Document")}</th>
//                                                         <th style={{ padding: "7px 10px", minWidth: "150px" }} rowSpan={2} colSpan={1}>{t("Date")}</th>
//                                                         <th style={{ padding: "7px 10px", minWidth: "150px" }} rowSpan={2} colSpan={1}>{t("Edited By")}</th>
//                                                         <th style={{ padding: "7px 10px", minWidth: "150px" }} rowSpan={2} colSpan={1}>{t("SendBack/Rejected")}</th>
//                                                         <th style={{ padding: "7px 10px", minWidth: "150px" }} rowSpan={2} colSpan={1}>{t("Remark(if any)")}</th>
//                                                         <th style={{ padding: "7px 10px", minWidth: "150px" }} rowSpan={2} colSpan={1}>{t("Updated Field(if any)")}</th>
//                                                         <th style={{ padding: "7px 10px" }} colSpan={3}>{t("Approved by")}</th>
//                                                     </tr>

//                                                     <tr style={{ width: "100%", color: 'white', border: 'none', height: '3rem', fontSize: "18px", fontWeight: "400" }}>
//                                                         <th style={{ padding: "7px 10px", minWidth: "160px" }}>{t("Deputy Engineer")}</th>
//                                                         <th style={{ padding: "7px 10px", minWidth: "160px" }}>{t("Department HOD(EE)")}</th>
//                                                         <th style={{ padding: "7px 10px", minWidth: "160px" }}>{t("Additional CEO")}</th>
//                                                     </tr>
//                                                 </thead>

//                                                 <tbody >
//                                                     {currentBills?.length === 0 ? (
//                                                         <tr>
//                                                             <td colSpan="20" style={{ textAlign: 'center', padding: '10px', backgroundColor: '#f9f9f9' }}>
//                                                                {t("No data available")}
//                                                             </td>
//                                                         </tr>
//                                                     ) : (
//                                                         currentBills?.map((proposal, index) => {
//                                                             const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
//                                                             return (
//                                                                 <tr key={index} style={{ backgroundColor: bgColor, fontSize: "18px", fontWeight: "400" }}>
//                                                                     <td style={{ padding: '8px 8px' }}>{(currentPage - 1) * billsPerPage + index + 1}</td>
//                                                                     <td style={{ padding: '8px 8px' }}>{proposal.HeadCode}</td>
//                                                                     <td style={{ padding: '8px 8px' }}>{proposal.Proposal_year}</td>
//                                                                     <td style={{ padding: '8px 8px' }}>{proposal.Work_name}</td>
//                                                                     <td style={{ padding: '8px 8px' }}>{proposal.District}</td>
//                                                                     <td style={{ padding: '8px 8px' }}>{proposal.Taluka}</td>
//                                                                     <td style={{ padding: '8px 8px' }}>{JSON.parse(proposal.Gram_panchayat).join(", ")}</td>
//                                                                     <td style={{ padding: '8px 8px' }}>{proposal.Constituency_name}</td>
//                                                                     <td style={{ padding: '8px 8px' }}>{proposal.Proposal_fileNumber}</td>
//                                                                     <td style={{ padding: '8px 8px' }}>{proposal.Proposal_amount}</td>
//                                                                     <td style={{ padding: '8px 8px' }}>{
//                                                                         proposal.Proposal_copy ? (
//                                                                             <span
//                                                                                 onClick={(e) => {
//                                                                                     e.preventDefault();
//                                                                                     SecureFileFetching(`ProposalFile/${proposal.Proposal_copy}`);
//                                                                                 }}
//                                                                                 // href={`${apiurl}/ProposalFile/${proposal.Proposal_copy}`}
//                                                                                 className='text-primary'
//                                                                                 style={{ cursor: "pointer" }}
//                                                                             >
//                                                                                 {proposal.Proposal_copy}
//                                                                             </span>
//                                                                         )
//                                                                             :
//                                                                             (
//                                                                                 <p className='fw-bold text-danger my-auto'>{t("No File")}</p>
//                                                                             )
//                                                                     }
//                                                                     </td>

//                                                                     <td style={{ padding: '8px 8px' }}>{
//                                                                         proposal.Additional_suppDoc ? (
//                                                                             <span
//                                                                                 // href={`${apiurl}/ProposalFile/${proposal.Additional_suppDoc}`}
//                                                                                 // target='_blank'
//                                                                                 onClick={(e) => {
//                                                                                     e.preventDefault();
//                                                                                     SecureFileFetching(`ProposalFile/${proposal.Proposal_copy}`);
//                                                                                 }}
//                                                                                 className='text-primary'
//                                                                                 style={{ cursor: "pointer" }}
//                                                                             >{proposal.Additional_suppDoc}
//                                                                             </span>
//                                                                         )
//                                                                             :
//                                                                             (
//                                                                                 <p className='fw-bold text-danger my-auto'>{t("No File")}</p>
//                                                                             )
//                                                                     }
//                                                                     </td>
//                                                                     <td style={{ padding: '8px 8px' }}>{new Date(proposal.created_at).toLocaleString()}</td>
//                                                                     <td style={{ padding: '8px 8px' }}>{
//                                                                         proposal.EditedBy ? (
//                                                                             <p className="text-black my-auto fw-bold">{proposal.EditedBy}</p>
//                                                                         ) : (
//                                                                             <p className="text-danger my-auto fw-bold">{t("No One")}</p>
//                                                                         )
//                                                                     }</td>
//                                                                     <td style={{ padding: '8px 8px' }}>{proposal.Status=="Pending" ? "-" : proposal.Status}</td>
//                                                                     <td  style={{ padding: '8px 8px' }}>{proposal.Remark || "NA"}</td>
//                                                                     <td  style={{ padding: '8px 8px' }}>{proposal.updatedFieldsStr || "NA"}</td>

//                                                                     <td style={{ padding: '8px', textAlign: 'center' }}>
//                                                                         {proposal.Approvance1 === 'true' ? (
//                                                                             <div className='m-auto'
//                                                                                 style={{
//                                                                                     width: '20px',
//                                                                                     height: '20px',
//                                                                                     borderRadius: '6px',
//                                                                                     backgroundColor: '#16C60C',
//                                                                                     border: 'none',
//                                                                                     display: 'flex',
//                                                                                     justifyContent: 'center',
//                                                                                     alignItems: 'center',
//                                                                                     fontSize: '13px',
//                                                                                     color: 'white',
//                                                                                     boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                                                                 }}
//                                                                             >
//                                                                                 ✓
//                                                                             </div>
//                                                                         ) : proposal.Approvance1 === 'false' ? (
//                                                                             <div
//                                                                                 className='m-auto'
//                                                                                 style={{
//                                                                                     width: '20px',
//                                                                                     height: '20px',
//                                                                                     borderRadius: '6px',
//                                                                                     backgroundColor: '#dc2626',
//                                                                                     border: 'none',
//                                                                                     display: 'flex',
//                                                                                     justifyContent: 'center',
//                                                                                     alignItems: 'center',
//                                                                                     fontSize: '13px',
//                                                                                     color: 'white',
//                                                                                     boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                                                                 }}
//                                                                             >
//                                                                                 ✕
//                                                                             </div>
//                                                                         ) : '-'}
//                                                                     </td>
//                                                                     <td style={{ padding: '8px', textAlign: 'center' }}>
//                                                                         {proposal.Approvance2 === 'true' ? (<div className='m-auto'
//                                                                             style={{
//                                                                                 width: '20px',
//                                                                                 height: '20px',
//                                                                                 borderRadius: '6px',
//                                                                                 backgroundColor: '#16C60C',
//                                                                                 border: 'none',
//                                                                                 display: 'flex',
//                                                                                 justifyContent: 'center',
//                                                                                 alignItems: 'center',
//                                                                                 fontSize: '13px',
//                                                                                 color: 'white',
//                                                                                 boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                                                             }}
//                                                                         >
//                                                                             ✓
//                                                                         </div>) : proposal.Approvance2 === 'false' ? (<div
//                                                                             className='m-auto'
//                                                                             style={{
//                                                                                 width: '20px',
//                                                                                 height: '20px',
//                                                                                 borderRadius: '6px',
//                                                                                 backgroundColor: '#dc2626',
//                                                                                 border: 'none',
//                                                                                 display: 'flex',
//                                                                                 justifyContent: 'center',
//                                                                                 alignItems: 'center',
//                                                                                 fontSize: '13px',
//                                                                                 color: 'white',
//                                                                                 boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                                                             }}
//                                                                         >
//                                                                             ✕
//                                                                         </div>) : '-'}
//                                                                     </td>
//                                                                     <td style={{ padding: '8px', textAlign: 'center' }}>
//                                                                         {proposal.Approvance3 === 'true' ? (<div className='m-auto'
//                                                                             style={{
//                                                                                 width: '20px',
//                                                                                 height: '20px',
//                                                                                 borderRadius: '6px',
//                                                                                 backgroundColor: '#16C60C',
//                                                                                 border: 'none',
//                                                                                 display: 'flex',
//                                                                                 justifyContent: 'center',
//                                                                                 alignItems: 'center',
//                                                                                 fontSize: '13px',
//                                                                                 color: 'white',
//                                                                                 boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                                                             }}
//                                                                         >
//                                                                             ✓
//                                                                         </div>) : proposal.Approvance3 === 'false' ? (<div
//                                                                             className='m-auto'
//                                                                             style={{
//                                                                                 width: '20px',
//                                                                                 height: '20px',
//                                                                                 borderRadius: '6px',
//                                                                                 backgroundColor: '#dc2626',
//                                                                                 border: 'none',
//                                                                                 display: 'flex',
//                                                                                 justifyContent: 'center',
//                                                                                 alignItems: 'center',
//                                                                                 fontSize: '13px',
//                                                                                 color: 'white',
//                                                                                 boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                                                             }}
//                                                                         >
//                                                                             ✕
//                                                                         </div>) : '-'}
//                                                                     </td>
//                                                                 </tr>

//                                                             );
//                                                         })
//                                                     )}
//                                                 </tbody>
//                                             </table>
//                                         )
//                                     }

//                                     {
//                                         typeofData == "State" && (
//                                             <table className='m-0 p-0' style={{ width: '100%', borderCollapse: 'collapse' }}>
//                                                 <thead>
//                                                     <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "18px" }}>
//                                                         <th style={{ padding: "7px 10px", minWidth: "60px" }} rowSpan={2} colSpan={1}>{t("Sr.No")}</th>
//                                                         <th style={{ padding: "7px 10px", minWidth: "200px" }} rowSpan={2} colSpan={1}>{t("Head Code")}</th> {/* changed from 9 to 7 */}
//                                                         <th style={{ padding: "7px 10px", minWidth: "110px" }} rowSpan={2} colSpan={1}>{t("Proposal Year")}</th>
//                                                         <th style={{ padding: "7px 10px", minWidth: "230px" }} rowSpan={2} colSpan={1}>{t("Work Name")}</th>
//                                                         <th style={{ padding: "7px 10px", minWidth: "120px" }} rowSpan={2} colSpan={1}>{t("District")}</th>
//                                                         <th style={{ padding: "7px 10px", minWidth: "120px" }} rowSpan={2} colSpan={1}>{t("Taluka")}</th>
//                                                         <th style={{ padding: "7px 10px", minWidth: "200px" }} rowSpan={2} colSpan={1}>{t("Gram Panchayat")}</th>
//                                                         <th style={{ padding: "7px 10px", minWidth: "150px" }} rowSpan={2} colSpan={1}>{t("Constituency Name")}</th>
//                                                         <th style={{ padding: "7px 10px", minWidth: "150px" }} rowSpan={2} colSpan={1}>{t("Proposal File Number")}</th>
//                                                         <th style={{ padding: "7px 10px", minWidth: "130px" }} rowSpan={2} colSpan={1}>{t("Work Amount")}</th>
//                                                         <th style={{ padding: "7px 10px", minWidth: "250px" }} rowSpan={2} colSpan={1}>{t("Proposal Copy")}</th>
//                                                         <th style={{ padding: "7px 10px", minWidth: "250px" }} rowSpan={2} colSpan={1}>{t("Additional Support Document")}</th>
//                                                         <th style={{ padding: "7px 10px", minWidth: "150px" }} rowSpan={2} colSpan={1}>{t("Date")}</th>
//                                                         <th style={{ padding: "7px 10px", minWidth: "150px" }} rowSpan={2} colSpan={1}>{t("Edited By")}</th>
//                                                         <th style={{ padding: "7px 10px", minWidth: "150px" }} rowSpan={2} colSpan={1}>{t("Status")}</th>

//                                                         {/* <th style={{ minWidth: "150px", padding: "8px" }}rowSpan={2} colSpan={1}>View Approvals</th> */}
//                                                         <th style={{ padding: "7px 10px" }} colSpan={2}>{t("Approved by")}</th> {/* changed from 9 to 7 */}
//                                                     </tr>

//                                                     <tr style={{ width: "100%", color: 'white', border: 'none', height: '3rem', fontSize: "18px", fontWeight: "400" }}>
//                                                         <th style={{ padding: "7px 10px", minWidth: "160px" }}>{t("RDD Section Officer")}</th>
//                                                         <th style={{ padding: "7px 10px", minWidth: "160px" }}>{t("Deputy Secretary")}</th>
//                                                     </tr>
//                                                 </thead>

//                                                 <tbody >
//                                                     {currentBills?.length === 0 ? (
//                                                         <tr>
//                                                             <td colSpan="30" style={{ textAlign: 'center', padding: '10px', backgroundColor: '#f9f9f9' }}>
//                                                                 {t("No data available")}
//                                                             </td>
//                                                         </tr>
//                                                     ) : (
//                                                         currentBills?.map((proposal, index) => {
//                                                             const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
//                                                             return (
//                                                                 <tr key={index} style={{ backgroundColor: bgColor, fontSize: "18px", fontWeight: "400" }}>
//                                                                     <td style={{ padding: '8px 8px' }}>{(currentPage - 1) * billsPerPage + index + 1}</td>
//                                                                     <td style={{ padding: '8px 8px' }}>{proposal.HeadCode}</td>
//                                                                     <td style={{ padding: '8px 8px' }}>{proposal.Proposal_year}</td>
//                                                                     <td style={{ padding: '8px 8px' }}>{proposal.Work_name}</td>
//                                                                     <td style={{ padding: '8px 8px' }}>{proposal.District}</td>
//                                                                     <td style={{ padding: '8px 8px' }}>{proposal.Taluka}</td>
//                                                                     <td style={{ padding: '8px 8px' }}>{JSON.parse(proposal.Gram_panchayat).join(", ")}</td>
//                                                                     <td style={{ padding: '8px 8px' }}>{proposal.Constituency_name}</td>
//                                                                     <td style={{ padding: '8px 8px' }}>{proposal.Proposal_fileNumber}</td>
//                                                                     <td style={{ padding: '8px 8px' }}>{proposal.Proposal_amount}</td>
//                                                                     <td style={{ padding: '8px 8px' }}>{
//                                                                         proposal.Proposal_copy ? (
//                                                                             <span
//                                                                                 onClick={(e) => {
//                                                                                     e.preventDefault();
//                                                                                     SecureFileFetching(`ProposalFile/${proposal.Proposal_copy}`);
//                                                                                 }}
//                                                                                 // href={`${apiurl}/ProposalFile/${proposal.Proposal_copy}`}
//                                                                                 className='text-primary'
//                                                                                 style={{ cursor: "pointer" }}
//                                                                             >
//                                                                                 {proposal.Proposal_copy}
//                                                                             </span>
//                                                                         )
//                                                                             :
//                                                                             (
//                                                                                 <p className='fw-bold text-danger my-auto'>{t("No File")}</p>
//                                                                             )
//                                                                     }
//                                                                     </td>

//                                                                     <td style={{ padding: '8px 8px' }}>{
//                                                                         proposal.Additional_suppDoc ? (
//                                                                             <span
//                                                                                 // href={`${apiurl}/ProposalFile/${proposal.Additional_suppDoc}`}
//                                                                                 // target='_blank'
//                                                                                 onClick={(e) => {
//                                                                                     e.preventDefault();
//                                                                                     SecureFileFetching(`ProposalFile/${proposal.Proposal_copy}`);
//                                                                                 }}
//                                                                                 className='text-primary'
//                                                                                 style={{ cursor: "pointer" }}
//                                                                             >{proposal.Additional_suppDoc}
//                                                                             </span>
//                                                                         )
//                                                                             :
//                                                                             (
//                                                                                 <p className='fw-bold text-danger my-auto'>{t("No File")}</p>
//                                                                             )
//                                                                     }
//                                                                     </td>
//                                                                     <td style={{ padding: '8px 8px' }}>{new Date(proposal.created_at).toLocaleString()}</td>
//                                                                     <td style={{ padding: '8px 8px' }}>{
//                                                                         proposal.EditedBy ? (
//                                                                             <p className="text-black my-auto fw-bold">{proposal.EditedBy}</p>
//                                                                         ) : (
//                                                                             <p className="text-danger my-auto fw-bold">{t("No One")}</p>
//                                                                         )
//                                                                     }</td>

//                                                                     <td style={{ padding: '8px 8px' }}>{proposal.Status}</td>

//                                                                     <td style={{ padding: '8px', textAlign: 'center' }}>
//                                                                         {proposal.Approvance5 === 'true' ? (
//                                                                             <div className='m-auto'
//                                                                                 style={{
//                                                                                     width: '20px',
//                                                                                     height: '20px',
//                                                                                     borderRadius: '6px',
//                                                                                     backgroundColor: '#16C60C',
//                                                                                     border: 'none',
//                                                                                     display: 'flex',
//                                                                                     justifyContent: 'center',
//                                                                                     alignItems: 'center',
//                                                                                     fontSize: '13px',
//                                                                                     color: 'white',
//                                                                                     boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                                                                 }}
//                                                                             >
//                                                                                 ✓
//                                                                             </div>
//                                                                         ) : proposal.Approvance5 === 'false' ? (
//                                                                             <div
//                                                                                 className='m-auto'
//                                                                                 style={{
//                                                                                     width: '20px',
//                                                                                     height: '20px',
//                                                                                     borderRadius: '6px',
//                                                                                     backgroundColor: '#dc2626',
//                                                                                     border: 'none',
//                                                                                     display: 'flex',
//                                                                                     justifyContent: 'center',
//                                                                                     alignItems: 'center',
//                                                                                     fontSize: '13px',
//                                                                                     color: 'white',
//                                                                                     boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                                                                 }}
//                                                                             >
//                                                                                 ✕
//                                                                             </div>
//                                                                         ) : '-'}
//                                                                     </td>
//                                                                     <td style={{ padding: '8px', textAlign: 'center' }}>
//                                                                         {proposal.Approvance6 === 'true' ? (<div className='m-auto'
//                                                                             style={{
//                                                                                 width: '20px',
//                                                                                 height: '20px',
//                                                                                 borderRadius: '6px',
//                                                                                 backgroundColor: '#16C60C',
//                                                                                 border: 'none',
//                                                                                 display: 'flex',
//                                                                                 justifyContent: 'center',
//                                                                                 alignItems: 'center',
//                                                                                 fontSize: '13px',
//                                                                                 color: 'white',
//                                                                                 boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                                                             }}
//                                                                         >
//                                                                             ✓
//                                                                         </div>) : proposal.Approvance6 === 'false' ? (<div
//                                                                             className='m-auto'
//                                                                             style={{
//                                                                                 width: '20px',
//                                                                                 height: '20px',
//                                                                                 borderRadius: '6px',
//                                                                                 backgroundColor: '#dc2626',
//                                                                                 border: 'none',
//                                                                                 display: 'flex',
//                                                                                 justifyContent: 'center',
//                                                                                 alignItems: 'center',
//                                                                                 fontSize: '13px',
//                                                                                 color: 'white',
//                                                                                 boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                                                             }}
//                                                                         >
//                                                                             ✕
//                                                                         </div>) : '-'}
//                                                                     </td>

//                                                                 </tr>
//                                                             );
//                                                         })
//                                                     )}
//                                                 </tbody>
//                                             </table>
//                                         )
//                                     }
//                                 </div>

//                                 <div className='col-12 mt-4 mb-2' >
//                                     <div className="row">
//                                         <div className='col-6'>
//                                             <p className="text-gray-600" style={{ fontSize: "14px", margin: 0 }}>{t("Showing")} {indexOfFirstBill + 1} {t("to")} {Math.min(indexOfLastBill, filteredBills.length)} {t("of")} {proposallist?.length} {t("entries")}</p>
//                                         </div>
//                                         <div className='col-6' style={{ display: 'flex', alignItems: 'center', justifyContent: "end" }}>
//                                             <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
//                                                 style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', width: '2rem' }}>&laquo;</button>
//                                             <button onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 1}
//                                                 style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>&lt;</button>
//                                             <button
//                                                 style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '20px', width: '2.4rem', border: '1px solid lightgrey', borderLeft: "none" }}>
//                                                 {currentPage}
//                                             </button>
//                                             <button onClick={() => setCurrentPage(currentPage + 1)} disabled={currentPage === totalPages}
//                                                 style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>&gt;</button>
//                                             <button onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages}
//                                                 style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>&raquo;</button>
//                                         </div>
//                                     </div>

//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                 </div>
//             </div>
//             <div>

//             </div>

//             {
//                 selectedProposal && (
//                     <div
//                         onClick={() => setSelectedProposal(null)}
//                         style={{
//                             position: 'fixed',
//                             top: 0, left: 0,
//                             width: '100vw',
//                             height: '100vh',
//                             backgroundColor: 'rgba(0, 0, 0, 0.84)',
//                             display: 'flex',
//                             justifyContent: 'center',
//                             alignItems: 'center',
//                             zIndex: 9999
//                         }}
//                     >
//                         <div
//                             onClick={(e) => e.stopPropagation()}
//                             style={{
//                                 backgroundColor: 'white',
//                                 padding: '40px 40px',
//                                 borderRadius: '20px',
//                                 width: '50%',
//                                 maxHeight: '90vh',
//                                 overflow: "hidden",
//                                 boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
//                                 position: 'relative'
//                             }}
//                         >

//                             <div className="col-12">

//                                 <div className="col-12  mb-3">
//                                     <div className="row">
//                                         <div className="col-6">
//                                             <h5 className='fw-bold'>{t("Proposal Approval Detail")}</h5>
//                                         </div>

//                                         <div className="col-6" style={{ display: 'flex', justifyContent: 'flex-end' }}>
//                                             <button
//                                                 onClick={() => setSelectedProposal(null)}
//                                                 style={{
//                                                     width: '32px',
//                                                     height: '32px',
//                                                     borderRadius: '50%',
//                                                     backgroundColor: 'red',
//                                                     border: 'none',
//                                                     display: 'flex',
//                                                     justifyContent: 'center',
//                                                     alignItems: "center",
//                                                     cursor: 'pointer',
//                                                     fontSize: '24px',
//                                                     fontWeight: 'bold',
//                                                     color: 'white',
//                                                     lineHeight: 1
//                                                 }}
//                                             >
//                                                 ×
//                                             </button>
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <div className="col-12" style={{ height: "59vh", overflowX: "hidden", overflowY: "scroll", scrollBehavior: "smooth" }}>
//                                     {
//                                         false &&
//                                         (
//                                             <table className='m-0 p-0' style={{ width: "100%" }}>
//                                                 <thead>
//                                                     <tr style={{ color: 'white', border: 'none', height: '3.5rem', fontSize: "18px", fontWeight: "400" }}>
//                                                         <th style={{ width: "15%", border: "1px solid white" }} rowSpan={2} colSpan={1}>{t("Proposal Name")}</th>
//                                                         <th style={{ width: "77%", border: "1px solid white" }} colSpan={6}>{t("Approved by")}</th> {/* changed from 9 to 7 */}
//                                                         <th style={{ width: "8%", textAlign: "center", border: "1px solid white" }} colSpan={1} rowSpan={2}>{t("Details")}</th>
//                                                     </tr>
//                                                     <tr style={{ width: "100%", color: 'white', border: 'none', height: '3rem' }}>
//                                                         <th style={{ width: "12%", border: "1px solid white" }}>{t("Deputy Engineer")}</th>
//                                                         <th style={{ width: "14%", border: "1px solid white" }}>{t("Department HOD(EE)")}</th>
//                                                         <th style={{ width: "12%", border: "1px solid white" }}>{t("Additional CEO")}</th>
//                                                         <th style={{ width: "13%", border: "1px solid white" }}>{t("RDD Checker (ASO)")}</th>
//                                                         <th style={{ width: "13%", border: "1px solid white" }}>{t("RDD Section Officer")}</th>
//                                                         <th style={{ width: "13%", border: "1px solid white" }}>{t("Deputy Secretary")}</th>
//                                                     </tr>
//                                                 </thead>

//                                                 <tbody >
//                                                     {currentBills?.length === 0 ? (
//                                                         <tr>
//                                                             <td colSpan="10" style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9' }}>
//                                                                {t("No data available")}
//                                                             </td>
//                                                         </tr>
//                                                     ) : (
//                                                         currentBills?.map((proposal, index) => {
//                                                             const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
//                                                             return (
//                                                                 <tr style={{ backgroundColor: bgColor }} key={proposal.DemandGenerationID || index}>
//                                                                     <td className='fw-bold' style={{ fontSize: "18px", padding: "5px" }}>{proposal.Work_name}</td>
//                                                                     <td style={{ padding: '8px', textAlign: 'center' }}>
//                                                                         {proposal.Approvance1 === 'true' ? (
//                                                                             <div className='m-auto'
//                                                                                 style={{
//                                                                                     width: '20px',
//                                                                                     height: '20px',
//                                                                                     borderRadius: '6px',
//                                                                                     backgroundColor: '#16C60C',
//                                                                                     border: 'none',
//                                                                                     display: 'flex',
//                                                                                     justifyContent: 'center',
//                                                                                     alignItems: 'center',
//                                                                                     fontSize: '13px',
//                                                                                     color: 'white',
//                                                                                     boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                                                                 }}
//                                                                             >
//                                                                                 ✓
//                                                                             </div>
//                                                                         ) : proposal.Approvance1 === 'false' ? (
//                                                                             <div
//                                                                                 className='m-auto'
//                                                                                 style={{
//                                                                                     width: '20px',
//                                                                                     height: '20px',
//                                                                                     borderRadius: '6px',
//                                                                                     backgroundColor: '#dc2626',
//                                                                                     border: 'none',
//                                                                                     display: 'flex',
//                                                                                     justifyContent: 'center',
//                                                                                     alignItems: 'center',
//                                                                                     fontSize: '13px',
//                                                                                     color: 'white',
//                                                                                     boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                                                                 }}
//                                                                             >
//                                                                                 ✕
//                                                                             </div>
//                                                                         ) : '-'}
//                                                                     </td>
//                                                                     <td style={{ padding: '8px', textAlign: 'center' }}>
//                                                                         {proposal.Approvance2 === 'true' ? (<div className='m-auto'
//                                                                             style={{
//                                                                                 width: '20px',
//                                                                                 height: '20px',
//                                                                                 borderRadius: '6px',
//                                                                                 backgroundColor: '#16C60C',
//                                                                                 border: 'none',
//                                                                                 display: 'flex',
//                                                                                 justifyContent: 'center',
//                                                                                 alignItems: 'center',
//                                                                                 fontSize: '13px',
//                                                                                 color: 'white',
//                                                                                 boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                                                             }}
//                                                                         >
//                                                                             ✓
//                                                                         </div>) : proposal.Approvance2 === 'false' ? (<div
//                                                                             className='m-auto'
//                                                                             style={{
//                                                                                 width: '20px',
//                                                                                 height: '20px',
//                                                                                 borderRadius: '6px',
//                                                                                 backgroundColor: '#dc2626',
//                                                                                 border: 'none',
//                                                                                 display: 'flex',
//                                                                                 justifyContent: 'center',
//                                                                                 alignItems: 'center',
//                                                                                 fontSize: '13px',
//                                                                                 color: 'white',
//                                                                                 boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                                                             }}
//                                                                         >
//                                                                             ✕
//                                                                         </div>) : '-'}
//                                                                     </td>
//                                                                     <td style={{ padding: '8px', textAlign: 'center' }}>
//                                                                         {proposal.Approvance3 === 'true' ? (<div className='m-auto'
//                                                                             style={{
//                                                                                 width: '20px',
//                                                                                 height: '20px',
//                                                                                 borderRadius: '6px',
//                                                                                 backgroundColor: '#16C60C',
//                                                                                 border: 'none',
//                                                                                 display: 'flex',
//                                                                                 justifyContent: 'center',
//                                                                                 alignItems: 'center',
//                                                                                 fontSize: '13px',
//                                                                                 color: 'white',
//                                                                                 boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                                                             }}
//                                                                         >
//                                                                             ✓
//                                                                         </div>) : proposal.Approvance3 === 'false' ? (<div
//                                                                             className='m-auto'
//                                                                             style={{
//                                                                                 width: '20px',
//                                                                                 height: '20px',
//                                                                                 borderRadius: '6px',
//                                                                                 backgroundColor: '#dc2626',
//                                                                                 border: 'none',
//                                                                                 display: 'flex',
//                                                                                 justifyContent: 'center',
//                                                                                 alignItems: 'center',
//                                                                                 fontSize: '13px',
//                                                                                 color: 'white',
//                                                                                 boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                                                             }}
//                                                                         >
//                                                                             ✕
//                                                                         </div>) : '-'}
//                                                                     </td>
//                                                                     <td style={{ padding: '8px', textAlign: 'center' }}>
//                                                                         {proposal.Approvance4 === 'true' ? (<div className='m-auto'
//                                                                             style={{
//                                                                                 width: '20px',
//                                                                                 height: '20px',
//                                                                                 borderRadius: '6px',
//                                                                                 backgroundColor: '#16C60C',
//                                                                                 border: 'none',
//                                                                                 display: 'flex',
//                                                                                 justifyContent: 'center',
//                                                                                 alignItems: 'center',
//                                                                                 fontSize: '13px',
//                                                                                 color: 'white',
//                                                                                 boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                                                             }}
//                                                                         >
//                                                                             ✓
//                                                                         </div>) : proposal.Approvance4 === 'false' ? (<div
//                                                                             className='m-auto'
//                                                                             style={{
//                                                                                 width: '20px',
//                                                                                 height: '20px',
//                                                                                 borderRadius: '6px',
//                                                                                 backgroundColor: '#dc2626',
//                                                                                 border: 'none',
//                                                                                 display: 'flex',
//                                                                                 justifyContent: 'center',
//                                                                                 alignItems: 'center',
//                                                                                 fontSize: '13px',
//                                                                                 color: 'white',
//                                                                                 boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                                                             }}
//                                                                         >
//                                                                             ✕
//                                                                         </div>) : '-'}
//                                                                     </td>
//                                                                     <td style={{ padding: '8px', textAlign: 'center' }}>
//                                                                         {proposal.Approvance5 === 'true' ? (<div className='m-auto'
//                                                                             style={{
//                                                                                 width: '20px',
//                                                                                 height: '20px',
//                                                                                 borderRadius: '6px',
//                                                                                 backgroundColor: '#16C60C',
//                                                                                 border: 'none',
//                                                                                 display: 'flex',
//                                                                                 justifyContent: 'center',
//                                                                                 alignItems: 'center',
//                                                                                 fontSize: '13px',
//                                                                                 color: 'white',
//                                                                                 boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                                                             }}
//                                                                         >
//                                                                             ✓
//                                                                         </div>) : proposal.Approvance5 === 'false' ? (<div
//                                                                             className='m-auto'
//                                                                             style={{
//                                                                                 width: '20px',
//                                                                                 height: '20px',
//                                                                                 borderRadius: '6px',
//                                                                                 backgroundColor: '#dc2626',
//                                                                                 border: 'none',
//                                                                                 display: 'flex',
//                                                                                 justifyContent: 'center',
//                                                                                 alignItems: 'center',
//                                                                                 fontSize: '13px',
//                                                                                 color: 'white',
//                                                                                 boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                                                             }}
//                                                                         >
//                                                                             ✕
//                                                                         </div>) : '-'}
//                                                                     </td>
//                                                                     <td style={{ padding: '8px', textAlign: 'center' }}>
//                                                                         {proposal.Approvance6 === 'true' ? (<div className='m-auto'
//                                                                             style={{
//                                                                                 width: '20px',
//                                                                                 height: '20px',
//                                                                                 borderRadius: '6px',
//                                                                                 backgroundColor: '#16C60C',
//                                                                                 border: 'none',
//                                                                                 display: 'flex',
//                                                                                 justifyContent: 'center',
//                                                                                 alignItems: 'center',
//                                                                                 fontSize: '13px',
//                                                                                 color: 'white',
//                                                                                 boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                                                             }}
//                                                                         >
//                                                                             ✓
//                                                                         </div>) : proposal.Approvance6 === 'false' ? (<div
//                                                                             className='m-auto'
//                                                                             style={{
//                                                                                 width: '20px',
//                                                                                 height: '20px',
//                                                                                 borderRadius: '6px',
//                                                                                 backgroundColor: '#dc2626',
//                                                                                 border: 'none',
//                                                                                 display: 'flex',
//                                                                                 justifyContent: 'center',
//                                                                                 alignItems: 'center',
//                                                                                 fontSize: '13px',
//                                                                                 color: 'white',
//                                                                                 boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                                                             }}
//                                                                         >
//                                                                             ✕
//                                                                         </div>) : '-'}
//                                                                     </td>
//                                                                     {/* <td style={{ padding: '8px' }}>{proposal.Proposal_copy}</td> */}
//                                                                     <td>
//                                                                         <button
//                                                                             className='m-auto'
//                                                                             onClick={() => selectedBillDetails(proposal.ProposalID)}
//                                                                             style={{
//                                                                                 cursor: 'pointer',
//                                                                                 background: "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
//                                                                                 color: 'white',
//                                                                                 border: 'none',
//                                                                                 padding: '6px 20px',
//                                                                                 borderRadius: '4px',
//                                                                                 fontSize: "18px",
//                                                                                 display: "flex",
//                                                                                 justifyContent: "center",
//                                                                                 alignItems: 'center',
//                                                                                 width: "80%"
//                                                                             }}
//                                                                         >
//                                                                             <img src="/view32.png" alt="view" className='me-1' style={{ width: "12px", height: "12px" }} />
//                                                                             {t("View")}
//                                                                         </button>
//                                                                     </td>
//                                                                 </tr>

//                                                             );
//                                                         })
//                                                     )}
//                                                 </tbody>
//                                             </table>
//                                         )
//                                     }

//                                     <table style={{ width: '100%', height: "100%", borderCollapse: 'collapse' }}>
//                                         <tbody>
//                                             {Object.entries(selectedProposal).map(([key, value], index) => (
//                                                 <>
//                                                     <tr key={key} style={{ backgroundColor: '#cce0f9', border: '1px solid #2B75D5' }}>
//                                                         <td style={{
//                                                             fontWeight: 'bold',
//                                                             padding: '8px',
//                                                             width: '40%',
//                                                             backgroundColor: '#2B75D5',
//                                                             color: 'white',
//                                                             border: '1px solid #cce0f9'
//                                                         }}>
//                                                             {key}
//                                                         </td>

//                                                         <td style={{ padding: '8px', textAlign: 'center', border: '1px solid #a1a1a1ff' }}>
//                                                             {
//                                                                 value === 'true' ? (
//                                                                     <div className='m-auto'
//                                                                         style={{
//                                                                             width: '20px',
//                                                                             height: '20px',
//                                                                             borderRadius: '6px',
//                                                                             backgroundColor: '#16C60C',
//                                                                             border: 'none',
//                                                                             display: 'flex',
//                                                                             justifyContent: 'center',
//                                                                             alignItems: 'center',
//                                                                             fontSize: '13px',
//                                                                             color: 'white',
//                                                                             boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                                                         }}
//                                                                     >
//                                                                         ✓
//                                                                     </div>
//                                                                 ) : value === 'false' ? (
//                                                                     <div
//                                                                         className='m-auto'
//                                                                         style={{
//                                                                             width: '20px',
//                                                                             height: '20px',
//                                                                             borderRadius: '6px',
//                                                                             backgroundColor: '#dc2626',
//                                                                             border: 'none',
//                                                                             display: 'flex',
//                                                                             justifyContent: 'center',
//                                                                             alignItems: 'center',
//                                                                             fontSize: '13px',
//                                                                             color: 'white',
//                                                                             boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                                                         }}
//                                                                     >
//                                                                         ✕
//                                                                     </div>
//                                                                 ) : '-'}
//                                                         </td>
//                                                     </tr>

//                                                 </>
//                                             ))}
//                                         </tbody>
//                                     </table>
//                                 </div>

//                             </div>

//                         </div>
//                     </div>
//                 )}

//         </>
//     )

// }

// export default CreateOutwards;

import React, { useContext, useEffect, useState } from "react";
import AdminContext from "../../StateContext/Application";
import { apiurl } from "../../../../path";
import { useLanguage } from "../../../../lang/langcontext/LanguageContext";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import GooglePagination from "../../styles/GooglePagination";
import { jwtDecode } from "jwt-decode";
// import { formatDateTime } from '../../../../utils/DateFormat';
import { filterStyle,filterWrapperStyle } from '../../styles/filterStyles';
import { useDepartmentFilter  } from '../../../../utils/DateFormat';

const CreateOutwards = () => {
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("Token");
    if (token) {
      try {
        // Decode the JWT token to get user details
        const decoded = jwtDecode(token);
        setUserData(decoded);
        console.log("Logged User Info:", decoded);
      } catch (error) {
        console.error("Invalid token:", error);
      }
    }
  }, []);
  const { language, toggleLanguage, t } = useLanguage();
  const context = useContext(AdminContext);
  const { GetProposallist, SecureFileFetching, Usermenu, GetBudgetHeadInfo, GetMyDepartmentAccess } =
    context;

  const { departments, departmentId, setDepartmentId, ready } = useDepartmentFilter(GetMyDepartmentAccess);

  const [technicalInwards, setTechnicalInwards] = useState([]);
  const [proposallist, setProposalList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const budgetEstimation = proposallist;
  const [filteredBills, setFilteredBills] = useState([]);
  const [typeofData, settypeofData] = useState("District");
  const [statusofData, setstatusofData] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [UserRole, setUserRole] = useState("");
  const [AllDistrict, setAllDistrict] = useState([]);
  const [TalukasofDistrict, setTalukasofDistrict] = useState([]);
  const [SelectedDistrict, setSelectedDistrict] = useState([]);
  const [dropdownDistrict, setDropdownDistrict] = useState("All District");
  const [SelectedTalukasofDistrict, setSelectedTalukasofDistrict] =
    useState("");
  const [openDistrict, setOpenDistrict] = useState(false);
  const billsPerPage = 10;
  const [selectedProposal, setSelectedProposal] = useState(null);
  const totalPages = Math.ceil(filteredBills.length / billsPerPage);
  const indexOfLastBill = currentPage * billsPerPage;
  const indexOfFirstBill = indexOfLastBill - billsPerPage;
  const sortedBills = Array.isArray(filteredBills)
    ? filteredBills
      .slice() // ✅ prevent state mutation
      .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
    : [];

  const currentBills = sortedBills.slice(indexOfFirstBill, indexOfLastBill);
  const [RoleID, setRoleID] = useState(null);
  const [HeadcodeRole, setHeadcodeRole] = useState(null);
  // const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);

  const [exportingPDF, setExportingPDF] = useState(false);
  const [loading, setloading] = useState(false);
  const displayedGRS = exportingPDF ? filteredBills : currentBills;
  const headerStyle = {
    padding: "12px 16px",
    whiteSpace: "nowrap",
    borderRight: "1px solid #e0e0e0",
    textTransform: "capitalize",
  };

  const proposalEstimate = async () => {
    let data = await GetProposallist("", "", "", departmentId);
    let res = await Usermenu();
    setRoleID(res?.Data?.RoleID);
    const { status, message, Tabletype, Role } = data;
    if (status) {
      setProposalList(message);
      setTechnicalInwards(message);
      settypeofData(Tabletype);
      setUserRole(Tabletype);
      setHeadcodeRole(Role);
    } else {
      alert(message);
      setProposalList([]);
      setTechnicalInwards([]);
    }
  };
  
  useEffect(() => {
    if (!ready) return; // wait until departments are loaded (avoids a double fetch)
    proposalEstimate();
  }, [ready, departmentId]);

//   const allDistricts = [
//     ...new Set(
//       AllDistrict?.map((d) =>
//         d.District_Marathi?.split("-")[0]?.trim()
//       )
//     )
//   ];
//   const districtList = [
//   ...new Set(
//     budgetEstimation
//       ?.map((item) => item.District)
//       .filter(Boolean)
//   ),
// ];
//   const isAllSelected = SelectedDistrict.length === allDistricts.length;

//////////////Addedd
const allDistricts = [
  ...new Set(
    AllDistrict?.map((d) =>
      (d?.District_Marathi || "").split("-")[0].trim()
    ).filter(Boolean)
  ),
].sort();
  const districtList = [
  ...new Set(
    budgetEstimation
      ?.map((item) => item.District)
      .filter(Boolean)
  ),
];
const isAllSelected =
  allDistricts.length > 0 &&
  SelectedDistrict.length === allDistricts.length;
  

  const toggleAllDistricts = () => {
    setSelectedDistrict(isAllSelected ? [] : allDistricts);
  };
  const handleDistrictToggle = (district) => {
    setSelectedDistrict((prev) =>
      prev.includes(district)
        ? prev.filter((d) => d !== district)
        : [...prev, district],
    );
  };

  useEffect(() => {
    let filtered = [...budgetEstimation];
    // 🔹 typeofdata filter
    if (
      typeofData === "District" &&
      HeadcodeRole === "State-Deputy Secretary"
    ) {
      filtered = filtered.filter(
        (item) =>
          item.HeadCode ===
          "3054-2419(Roads and bridge repair maintenance program)",
      );
    } else if (
      typeofData === "State" &&
      HeadcodeRole === "State-Deputy Secretary"
    ) {
      filtered = filtered.filter(
        (item) => item.HeadCode === "2515-1238(MLA Representative)",
      );
    }

    // 🔹 District filter
    if (SelectedDistrict?.length > 0) {
      filtered = filtered.filter((item) => {
        const itemDistrict = item?.District || "";

        return SelectedDistrict.some(
          (district) =>
            itemDistrict === district ||
            itemDistrict.startsWith(`${district}-`)
        );
      });
    }

    // 🔹 Taluka filter
    if (SelectedTalukasofDistrict) {
      filtered = filtered.filter(
        (item) =>
          item.Taluka === SelectedTalukasofDistrict ||
          item.ULBNameMarathi === SelectedTalukasofDistrict
      );
    }

    // 🔹 Status filter
    if (statusofData) {
      // if (statusofData === "Pending") {
      //     filtered = filtered.filter(
      //         item =>
      //              (item.Status == "Pending" ||  item.Status == "SendBack"  ) &&   item.Status !=="Rejected" &&
      //             (
      //                 item.Approvance1 === "false" ||
      //                 item.Approvance2 === "false" ||
      //                 item.Approvance3 === "false"
      //                 // item.Approvance4 ==="false" ||
      //                 // item.Approvance5 === "false" ||
      //                 // item.Approvance6 === "false"
      //             )
      //     );
      // }
      if (statusofData === "Pending") {
        filtered = filtered.filter((item) => {
          let isPending = false;

          // ✅ District Level Approval
          if (typeofData === "District") {
            isPending =
              (item.Status === "Pending" || item.Status === "SendBack") &&
              item.Status !== "Rejected" &&
              (item.Approvance1 === "false" ||
                item.Approvance2 === "false" ||
                item.Approvance3 === "false");
          }

          // ✅ State Level Approval
          else if (typeofData === "State") {
            isPending =
              (item.Status === "Pending" || item.Status === "SendBack") &&
              item.Status !== "Rejected" &&
              (item.Approvance5 === "false" || item.Approvance6 === "false");
          }

          // ✅ Deputy Secretary HeadCode Filter
          let headCodeMatch = true;

          if (
            typeofData === "District" &&
            HeadcodeRole === "State-Deputy Secretary"
          ) {
            headCodeMatch =
              item.HeadCode ===
              "3054-2419(Roads and bridge repair maintenance program)";
          } else if (
            typeofData === "State" &&
            HeadcodeRole === "State-Deputy Secretary"
          ) {
            headCodeMatch = item.HeadCode === "2515-1238(MLA Representative)";
          }

          return isPending && headCodeMatch;
        });
      } else if (statusofData === "Rejected") {
        filtered = filtered.filter(
          (item) =>
            item.Status !== "Pending" &&
            item.Status !== "SendBack" &&
            (item.Approvance1 === "false" ||
              item.Approvance2 === "false" ||
              item.Approvance3 === "false"),
          // item.Approvance5 === "false" ||
          // item.Approvance6 === "false"
        );
      } else if (statusofData === "Approved") {
        filtered = filtered.filter((item) => {
          let isApproved = false;

          // ✅ District Level Approval
          if (typeofData === "District") {
            isApproved =
              item.Approvance1 === "true" &&
              item.Approvance2 === "true" &&
              item.Approvance3 === "true";
          }

          // ✅ State Level Approval
          else if (typeofData === "State") {
            isApproved =
              item.Approvance5 === "true" && item.Approvance6 === "true";
          }

          // ✅ Deputy Secretary HeadCode Filter
          let headCodeMatch = true;

          if (
            typeofData === "District" &&
            HeadcodeRole === "State-Deputy Secretary"
          ) {
            headCodeMatch =
              item.HeadCode ===
              "3054-2419(Roads and bridge repair maintenance program)";
          } else if (
            typeofData === "State" &&
            HeadcodeRole === "State-Deputy Secretary"
          ) {
            headCodeMatch = item.HeadCode === "2515-1238(MLA Representative)";
          }

          return isApproved && headCodeMatch;
        });
      } else {
        filtered = filtered.filter((item) => item.Status === statusofData);
      }
    }

    // 🔹 Search filter
    if (searchTerm.trim()) {
      const lower = searchTerm.toLowerCase();
      filtered = filtered.filter((item) =>
        Object.values(item).some((val) =>
          String(val ?? "")
            .toLowerCase()
            .includes(lower),
        ),
      );
    }

    setFilteredBills(filtered);
    setCurrentPage(1);
  }, [
    budgetEstimation,
    SelectedDistrict,
    SelectedTalukasofDistrict,
    statusofData,
    searchTerm,
    typeofData,
    HeadcodeRole,
  ]);
  const selectedBillDetails = (BillID) => {
    const result = budgetEstimation
      .filter((item) => item.ProposalID == BillID)
      .map((item) => ({
        "Deputy Engineer": item.Approvance1,
        "Department HOD(EE)": item.Approvance2,
        "Additional CEO": item.Approvance3,
        "RDD Checker (ASO)": item.Approvance4,
        "RDD Section Officer": item.Approvance5,
        // "Deputy Secretary": item.Approvance6,
      }));

    setSelectedProposal(result[0]);
  };

  const FetchGramPanachayatInfo = async () => {
    try {
      let res = await GetBudgetHeadInfo("null", "AllDistrict");
      // console.log("Data i get:: ", res);
      setAllDistrict(res);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    FetchGramPanachayatInfo();
  }, []);


  useEffect(() => {
    if (
      userData?.Department_Name === "District" &&
      userData?.District
    ) {
      // District login → show only logged-in district talukas
      const res = AllDistrict.filter(
        (item) => item.District_Marathi === userData.District
      );

      setTalukasofDistrict(res);
    }
    else if (SelectedDistrict?.length > 0) {
    // State login → taluka depends on selected district(s)
    const res = AllDistrict.filter((item) => {
        const itemDistrict = item?.District_Marathi || "";

        return SelectedDistrict.some(
            (district) =>
                itemDistrict === district ||
                itemDistrict.startsWith(`${district}-`)
        );
    });

    setTalukasofDistrict(res);
}
    else {
      setTalukasofDistrict([]);
      setSelectedTalukasofDistrict("");
    }
  }, [SelectedDistrict, AllDistrict, userData]);

  //--> old code
  // useEffect(() => {
  //   if (SelectedDistrict?.length > 0) {
  //     const res = AllDistrict.filter((item) =>
  //       SelectedDistrict.includes(item.District_Marathi),
  //     );
  //     if (SelectedDistrict.length > 1) {
  //       setTalukasofDistrict([]);
  //     } else {
  //       setTalukasofDistrict(res);
  //     }
  //   } else {
  //     // ✅ ONLY clear dependent data
  //     setSelectedTalukasofDistrict([]);
  //     setTalukasofDistrict([]);
  //   }
  // }, [SelectedDistrict, AllDistrict]);

  useEffect(() => {
    setSelectedTalukasofDistrict(""); // 🔹 clear taluka on district change
  }, [SelectedDistrict]);

  const totalProposalAmount = filteredBills?.reduce((sum, item) => {
    const amount = Number(item?.Proposal_amount);
    return sum + (isNaN(amount) ? 0 : amount);
  }, 0);

  const exportTableByClassToExcel = async (
    filteredBills,
    filename = "Proposals.xlsx",
  ) => {
    if (!Array.isArray(filteredBills) || filteredBills.length === 0) {
      alert("No data available");
      return;
    }
    setloading(true);
    await new Promise((resolve) => setTimeout(resolve, 1000));
    try {
      let totalProposalAmount = 0;

      const excelData = filteredBills.map((proposal, index) => {
        const amount = Number(proposal.Proposal_amount || 0);
        totalProposalAmount += amount;

        let gramPanchayat = "";
        try {
          gramPanchayat = proposal.Gram_panchayat
            ? JSON.parse(proposal.Gram_panchayat).join(", ")
            : "";
        } catch {
          gramPanchayat = "";
        }

        return {
          "Sr.No": index + 1,
          "Proposal Year": proposal.Proposal_year || "",
          // "Head Code": proposal.HeadCode || "",
          "Work Name": proposal.Work_name || "",
          // "Job ID": proposal.JOB_ID || "-",
          "District": proposal.District || "",
          "Taluka": proposal.Taluka || "",
          "Gram Panchayat": gramPanchayat,
          "Constituency Name": proposal.Constituency_name || "",
          "Proposal File Number": proposal.Proposal_fileNumber || "",
          "Work Amount": proposal.Proposal_amount,
          "Class of Work": proposal.classOfWork || "",

          // "Proposal Copy": proposal.Proposal_copy || "No File",
          // "Additional Support Document":
          //     proposal.Additional_suppDoc || "No File",

          "Creation Date": proposal.created_at
            ? new Date(proposal.created_at).toLocaleString()
            : "",

          "Edited By": proposal.EditedBy || "No One",
          "SendBack/Rejected":
            proposal.Status === "Pending" ? "-" : proposal.Status || "-",

          "Updated Field(if any)": proposal.updatedFieldsStr || "NA",
          "Remark(if any)": proposal.Remark || "NA",

          "RDD Section Officer":
            proposal.Approvance === "true"
              ? "✓"
              : proposal.Approvance5 === "false"
                ? "✕"
                : "-",

          // "Deputy Secretary":
          //   proposal.Approvance6 === "true"
          //     ? "✓"
          //     : proposal.Approvance6 === "false"
          //       ? "✕"
          //       : "-",

          // "Additional CEO":
          //     proposal.Approvance3 === "true"
          //         ? "✓"
          //         : proposal.Approvance3 === "false"
          //             ? "✕"
          //             : "-"
        };
      });

      // TOTAL ROW
      excelData.push({
        "Sr.No": "",
        "Proposal Year": "",
        "Work Name": "",
        // "Head Code": "",
        // "Year": "",
        // "Job ID": "",
        "District": "",
        "Taluka": "",
        "Gram Panchayat": "",
        "Constituency Name": "",
        "Proposal File Number": "TOTAL",
        "Work Amount": totalProposalAmount,
        "Class of Work": "",

        // "Proposal Copy": "",
        // "Additional Support Document": "",
        "Creation Date": "",
        "Edited By": "",
        "SendBack/Rejected": "",
        "Updated Field(if any)": "",
        "Remark(if any)": "",
        // "Deputy Engineer": "",
        // "Department HOD(EE)": "",
        // "Additional CEO": ""
        "RDD Section Officer": "",
        // "Deputy Secretary": ""
      });

      const worksheet = XLSX.utils.json_to_sheet(excelData);

      worksheet["!cols"] = Object.keys(excelData[0]).map(() => ({ wch: 22 }));
      worksheet["!freeze"] = { xSplit: 0, ySplit: 1 };
      worksheet["!autofilter"] = {
        ref: XLSX.utils.encode_range({
          s: { r: 0, c: 0 },
          e: { r: excelData.length, c: Object.keys(excelData[0]).length - 1 },
        }),
      };

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Proposals");
      XLSX.writeFile(workbook, filename);
    } catch (error) {
      console.error("Excel Export Error:", error);
    } finally {
      setloading(false); // ✅ ALWAYS stop loader
    }
  };

  // const downloadTableOnlyAsPDF = async (tableClass, filename, title) => {
  //   const CHUNK_SIZE = 500; // 🔥 adjust (300–500 recommended)

  //   setExportingPDF(true);
  //   setloading(true);

  //   // Allow loader to render
  //   await new Promise((resolve) => setTimeout(resolve, 600));

  //   const originalTable = document.querySelector(`.${tableClass}`);
  //   if (!originalTable) {
  //     setExportingPDF(false);
  //     setloading(false);
  //     return;
  //   }

  //   try {
  //     const originalRows = originalTable.querySelectorAll("tbody tr");
  //     const totalRows = originalRows.length;

  //     for (let start = 0; start < totalRows; start += CHUNK_SIZE) {
  //       const end = Math.min(start + CHUNK_SIZE, totalRows);

  //       // 🔥 Clone table
  //       const table = originalTable.cloneNode(true);
  //       const rows = table.querySelectorAll("tbody tr");

  //       // Remove rows outside chunk
  //       rows.forEach((row, index) => {
  //         if (index < start || index >= end) {
  //           row.remove();
  //         }
  //       });

  //       document.body.appendChild(table);

  //       const pdf = new jsPDF("p", "mm", "a4");
  //       const pageWidth = pdf.internal.pageSize.getWidth();
  //       const pageHeight = pdf.internal.pageSize.getHeight();

  //       const topMargin = 25;
  //       const sideMargin = 10;
  //       const bottomMargin = 15;

  //       pdf.setFontSize(16);
  //       pdf.setFont("helvetica", "bold");
  //       pdf.text(`${title} (${start + 1} - ${end})`, pageWidth / 2, 15, {
  //         align: "center",
  //       });

  //       const canvas = await html2canvas(table, {
  //         scale: 1,
  //         useCORS: true,
  //         backgroundColor: "#2C78DB",
  //       });

  //       const imgWidth = pageWidth - sideMargin * 2;
  //       const pxToMm = imgWidth / canvas.width;

  //       const usablePageHeightMm = pageHeight - topMargin - bottomMargin;
  //       const usablePageHeightPx = usablePageHeightMm / pxToMm;

  //       let renderedHeight = 0;
  //       let pageNumber = 0;

  //       while (renderedHeight < canvas.height) {
  //         const sliceHeight = Math.min(
  //           usablePageHeightPx,
  //           canvas.height - renderedHeight,
  //         );

  //         const pageCanvas = document.createElement("canvas");
  //         const context = pageCanvas.getContext("2d");

  //         pageCanvas.width = canvas.width;
  //         pageCanvas.height = sliceHeight;

  //         context.drawImage(
  //           canvas,
  //           0,
  //           renderedHeight,
  //           canvas.width,
  //           sliceHeight,
  //           0,
  //           0,
  //           canvas.width,
  //           sliceHeight,
  //         );

  //         const imgData = pageCanvas.toDataURL("image/jpeg", 0.85);

  //         if (pageNumber > 0) pdf.addPage();

  //         pdf.addImage(
  //           imgData,
  //           "JPEG",
  //           sideMargin,
  //           topMargin,
  //           imgWidth,
  //           sliceHeight * pxToMm,
  //         );

  //         renderedHeight += sliceHeight;
  //         pageNumber++;
  //       }

  //       pdf.save(`${filename}_${start + 1}_to_${end}.pdf`);

  //       document.body.removeChild(table);

  //       // 🔥 Small delay to prevent UI freeze
  //       await new Promise((resolve) => setTimeout(resolve, 300));
  //     }
  //   } catch (error) {
  //     console.error("PDF Export Error:", error);
  //   } finally {
  //     setExportingPDF(false);
  //     setloading(false);
  //   }
  // };

    const downloadTableOnlyAsPDF = async (tableClass, filename, title) => {
        const CHUNK_SIZE = 500;
        setExportingPDF(true);
        setloading(true);
        await new Promise((resolve) => setTimeout(resolve, 600));
        const originalTable = document.querySelector(
            `.${tableClass}`);

        if (!originalTable) {
            setExportingPDF(false);
            setloading(false);
            return;
        }

        try {
            const originalThead =
                originalTable.querySelector("thead");

            if (!originalThead) {
                console.error("Table <thead> not found");
                return;
            }

            const headerCells = Array.from(
                originalThead.querySelectorAll("th")
            );

            const headers = headerCells.map((th) =>
                th.innerText
                    .replace(/\s+/g, " ")
                    .trim()
                    .toLowerCase()
            );

            console.log("PDF Headers:", headers);

            const AMOUNT_HEADERS = [
                "amount",
                "total amount",
                "demand amount",
                "bill amount",
                "approved amount",
                "approved work order amount",
                "work cost",
                "gross amount",
                "net amount",
                "deduction amount"
            ];

            let amountColumnIndex = -1;

            for (let i = 0; i < headers.length; i++) {
                if (
                    AMOUNT_HEADERS.some((name) => headers[i].includes(name))
                ) {
                    amountColumnIndex = i;
                    break;
                }
            }

            const originalRows = Array.from(originalTable.querySelectorAll("tbody tr"));

            // Remove existing total rows
            const dataRows = originalRows.filter(
                (row) => {
                    const text = row.innerText
                        .replace(/\s+/g, " ")
                        .trim()
                        .toLowerCase();

                    return !(
                        text.startsWith("page total") ||
                        text.startsWith("gross total") ||
                        text.startsWith("total rows") ||
                        text === "total"
                    );
                }
            );

            const totalRows = dataRows.length;

            if (totalRows === 0) {
                alert("No data available");
                return;
            }

            let grandTotal = 0;
            if (amountColumnIndex !== -1) {
                dataRows.forEach((row) => {
                    const cells = row.querySelectorAll("td");
                    const amountCell = cells[amountColumnIndex];
                    if (!amountCell) return;

                    let value = amountCell.innerText || "";
                    value = value
                        .replace(/₹/g, "")
                        .replace(/Rs\.?/gi, "")
                        .replace(/,/g, "")
                        .replace(/\s/g, "")
                        .trim();

                    const amount = parseFloat(value);
                    if (!isNaN(amount)) {
                        grandTotal += amount;
                    }
                });
            }

            const formattedGrandTotal = grandTotal.toLocaleString("en-IN",
                {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });

            for (
                let start = 0;
                start < totalRows;
                start += CHUNK_SIZE
            ) {

                const end = Math.min(start + CHUNK_SIZE, totalRows);
                const table = originalTable.cloneNode(false);
                const thead = originalThead.cloneNode(true);
                thead.style.display = "table-header-group";
                thead.style.visibility = "visible";
                thead.style.position = "static";
                table.appendChild(thead);

                const tbody = document.createElement("tbody");
                for (
                    let i = start;
                    i < end;
                    i++
                ) {
                    const clonedRow = dataRows[i].cloneNode(true);
                    // Reset Sr.No.
                    const firstCell = clonedRow.querySelector("td");
                    if (firstCell) { firstCell.textContent = i + 1; }
                    tbody.appendChild(clonedRow);
                }

                if (end === totalRows) {

                    const totalRow = document.createElement("tr");
                    const columnCount = headers.length;

                    if (
                        amountColumnIndex !== -1
                    ) {

                        const labelCell = document.createElement("td");
                        labelCell.colSpan = amountColumnIndex;
                        labelCell.innerText = "Total";
                        labelCell.style.fontWeight = "bold";
                        labelCell.style.textAlign = "right";
                        labelCell.style.padding = "8px";
                        labelCell.style.border = "1px solid #000";
                        totalRow.appendChild(labelCell);
                        const amountCell = document.createElement("td");
                        amountCell.innerText = formattedGrandTotal;
                        amountCell.style.fontWeight = "bold";
                        amountCell.style.textAlign = "right";
                        amountCell.style.padding = "8px";
                        amountCell.style.border = "1px solid #000";
                        totalRow.appendChild(amountCell);

                        const remainingColumns = columnCount - amountColumnIndex - 1;
                        if (
                            remainingColumns > 0
                        ) {
                            const emptyCell = document.createElement("td");
                            emptyCell.colSpan = remainingColumns;
                            emptyCell.style.border = "1px solid #000";
                            totalRow.appendChild(emptyCell);
                        }

                    } else {
                        const labelCell = document.createElement("td");
                        labelCell.colSpan = Math.max(columnCount - 1, 1);
                        labelCell.innerText = "Total";
                        labelCell.style.fontWeight = "bold";
                        labelCell.style.textAlign = "right";
                        labelCell.style.border = "1px solid #000";
                        totalRow.appendChild(labelCell);
                        const amountCell = document.createElement("td");

                        amountCell.innerText = formattedGrandTotal;
                        amountCell.style.fontWeight = "bold";
                        amountCell.style.textAlign = "right";
                        amountCell.style.border = "1px solid #000";
                        totalRow.appendChild(amountCell);
                    }
                    tbody.appendChild(totalRow);
                }
                table.appendChild(tbody);
                table.style.position = "absolute";
                table.style.left = "-99999px";
                table.style.top = "0";
                table.style.display = "table";
                table.style.visibility = "visible";
                table.style.backgroundColor = "#ffffff";
                table.style.width = originalTable.offsetWidth + "px";
                table.style.borderCollapse = "collapse";
                const pdfHeaders =
                    table.querySelectorAll("thead th");

                pdfHeaders.forEach((th) => {
                    th.style.display = "table-cell";
                    th.style.visibility = "visible";
                    th.style.position = "static";
                    th.style.backgroundColor = "#2C78DB";
                    th.style.color = "#ffffff";
                    th.style.fontWeight = "bold";
                    th.style.border = "1px solid #000";
                    th.style.padding = "6px";
                });

                table.querySelectorAll("tbody td")
                    .forEach((td) => {
                        td.style.visibility = "visible";
                        td.style.border = "1px solid #000";
                        td.style.padding = "6px";
                    });

                document.body.appendChild(table);

                const pdf = new jsPDF("p", "mm", "a4");
                const pageWidth = pdf.internal.pageSize.getWidth();
                const pageHeight = pdf.internal.pageSize.getHeight();
                const topMargin = 25;
                const sideMargin = 10;
                const bottomMargin = 15;

                pdf.setFontSize(16);

                pdf.setFont("helvetica", "bold");

                pdf.text(`${title} (${start + 1} - ${end})`,
                    pageWidth / 2,
                    15,
                    {
                        align: "center"
                    }
                );

                const canvas = await html2canvas(table,
                    {
                        scale: 1,
                        useCORS: true,
                        backgroundColor: "#2C78DB",
                        scrollX: 0,
                        scrollY: 0,
                        windowWidth: table.scrollWidth
                    }
                );

                const imgWidth = pageWidth - sideMargin * 2;
                const pxToMm = imgWidth / canvas.width;
                const usablePageHeightMm = pageHeight - topMargin - bottomMargin;
                const usablePageHeightPx = usablePageHeightMm / pxToMm;
                let renderedHeight = 0;
                let pageNumber = 0;

                while (
                    renderedHeight < canvas.height
                ) {

                    const sliceHeight = Math.min(
                        usablePageHeightPx,
                        canvas.height - renderedHeight
                    );

                    const pageCanvas = document.createElement("canvas");
                    const context = pageCanvas.getContext("2d");
                    pageCanvas.width = canvas.width;
                    pageCanvas.height = sliceHeight;

                    context.drawImage(
                        canvas,
                        0,
                        renderedHeight,
                        canvas.width,
                        sliceHeight,
                        0,
                        0,
                        canvas.width,
                        sliceHeight
                    );

                    const imgData = pageCanvas.toDataURL("image/jpeg", 0.85);

                    if (pageNumber > 0) {
                        pdf.addPage();
                    }

                    pdf.addImage(
                        imgData,
                        "JPEG",
                        sideMargin,
                        topMargin,
                        imgWidth,
                        sliceHeight *
                        pxToMm
                    );

                    renderedHeight += sliceHeight;
                    pageNumber++;
                }

                pdf.save(
                    `${filename}_${start + 1}_to_${end}.pdf`);

                if (
                    document.body.contains(table)
                ) {
                    document.body.removeChild(table);
                }

                await new Promise((resolve) => setTimeout(resolve, 300));
            }
        } catch (error) {
            alert(
                "Error while generating PDF."
            );
        } finally {
            setExportingPDF(false);
            setloading(false);
        }
    };
  const pageProposalAmount = currentBills?.reduce((sum, item) => {
    const amount = Number(item?.Proposal_amount);
    return sum + (isNaN(amount) ? 0 : amount);
  }, 0);
const formatDateTime = (date) => {
    if (!date) return "-";

    const [datePart, timePart] = date.split(" ");
    if (!datePart || !timePart) return "-";

    const [year, month, day] = datePart.split("-");
    const [hour, minute, second] = timePart.split(":");

    const dateObj = new Date(
        Number(year),
        Number(month) - 1,
        Number(day),
        Number(hour),
        Number(minute),
        Number(second)
    );

    return dateObj.toLocaleString("en-IN", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
    });
};

// //////////////////Addeddd
const uniqueTalukas = [
  ...new Set(
    (TalukasofDistrict || [])
      .map((val) => String(val?.ULBNameMarathi || val?.Taluka || "").trim())
      .filter(Boolean)
  ),
].sort((a, b) => a.localeCompare(b, "mr"));
  return (
    <>
      <div
        className="col-12"
        style={{
          backgroundColor: "#EFF3F8",
          height: "90vh",
          overflowX: "hidden",
          overflowY: "scroll",
          position: "relative",
        }}
      >
        <div
          style={{
            filter: loading ? "blur(4px)" : "none",
            pointerEvents: loading ? "none" : "auto",
            transition: "0.2s ease",
          }}
        >
          <div className="col-11 m-auto">
            <div className="col-12">
              <div className="col-12 px-4 mb-4 mt-3">
                {/* ================= ROW 1 ================= */}
                <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap">
                  <h5 className="fw-bold d-flex align-items-center m-0">
                    <img
                      src="/GR-Approval64.png"
                      alt="Technical Approval"
                      style={{
                        width: "24px",
                        height: "24px",
                        marginRight: "6px",
                      }}
                    />
                    {[24, 25, 29, 40, 41].includes(RoleID)
                      ? t("Proposal Status")
                      : t("Proposal Outwards List")}
                  </h5>
                  <div className="d-flex gap-2">
                    <button
                      className="btn btn-success"
                      onClick={() =>
                        exportTableByClassToExcel(
                          filteredBills,
                          "Proposals.xlsx",
                        )
                      }
                    >
                      {t("Download Excel")}
                    </button>

                    <button
                      className="btn btn-danger"
                      onClick={() =>
                        downloadTableOnlyAsPDF(
                          "Proposaloutward",
                          "Proposaloutward.pdf",
                          "Proposal outward Report",
                        )
                      }
                    >
                      {t("Download PDF")}
                    </button>
                  </div>
                </div>

                {/* ================= ROW 2 ================= */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    flexWrap: "nowrap"
                  }}
                >

                  {departments.length > 1 && (
                    <select
                      value={departmentId}
                      onChange={(e) => setDepartmentId(e.target.value)}
                      style={filterStyle}
                    >
                      <option value="">{t("All Departments")}</option>
                      {departments.map((d) => (
                        <option key={d.id} value={d.id}>
                          {d.name || d.id}
                        </option>
                      ))}
                    </select>
                  )}

                  {/* Data Type */}
                  {UserRole === "State" && RoleID == 29 && (
                    <select
                      value={typeofData}
                      onChange={(e) => settypeofData(e.target.value)}
                      style={filterStyle}
                    >
                      <option value="" disabled selected>
                        Choose Data
                      </option>

                      <option value="District">
                        3054-2419(Roads and bridge repair maintenance program)
                      </option>

                      <option value="State">
                        2515-1238(MLA Representative)
                      </option>
                    </select>
                  )}

                  {/* Status */}
                  <select
                    value={statusofData}
                    onChange={(e) => setstatusofData(e.target.value)}
                    style={filterStyle}
                  >
                    <option value="">{t("All")}</option>
                    <option value="Approved">{t("Approved")}</option>
                    <option value="Pending">{t("Pending")}</option>
                    <option value="Rejected">{t("Rejected")}</option>
                  </select>

                  {RoleID === 17 && (
                    <>
                      {/* <div className="col-2 text-end">
        <label className="fw-bold">{t("District")}</label>
      </div> */}

                      <div style={filterWrapperStyle}>
                        <select
                          className="w-100 py-2 px-3"
                          value={dropdownDistrict}
                          onChange={(e) => setDropdownDistrict(e.target.value)}
                          style={filterStyle}
                        >
                          <option value="All District">
                            {t("All Division")}
                          </option>

                          {districtList.map((district, index) => (
                            <option key={index} value={district}>
                              {district}
                            </option>
                          ))}
                        </select>
                      </div>
                    </>
                  )}

                  {/* District */}
                  {(UserRole === "State" ||
                    HeadcodeRole === "State-RDD Section Officer" ||
                    HeadcodeRole === "State-RDD Checker(ASO)") && (
                      <div style={filterWrapperStyle}>

                        {/* Trigger */}
                        <div
                          onClick={() => setOpenDistrict(true)}
                          style={filterStyle}
                        >
                          {SelectedDistrict.length > 0
                            ? SelectedDistrict.join(", ")
                            : t("Select District")}
                        </div>

                        {/* Dropdown */}
                        {openDistrict && (
                          <div
                            style={{
                              position: "absolute",
                              top: "100%",
                              left: 0,
                              width: "100%",
                              background: "#fff",
                              border: "1px solid #ccc",
                              borderRadius: "8px",
                              boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
                              zIndex: 9999,
                              fontSize: "13px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis"
                            }}
                          >
                            <label
                              style={{
                                display: "flex",
                                alignItems: "center",
                                padding: "6px 8px",
                                borderBottom: "1px solid #eee",
                                cursor: "pointer",
                                fontSize: "13px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis"
                              }}
                            >
                              <input
                                type="checkbox"
                                checked={isAllSelected}
                                onChange={toggleAllDistricts}
                                style={{ marginRight: "6px" }}
                              />

                              {t("All Districts")}
                            </label>

                            {/* Options */}
                            <div
                              style={{
                                maxHeight: "150px",
                                overflowY: "auto"
                              }}
                            >
                              {allDistricts.map((district, index) => (
                                <label
                                  key={index}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    padding: "6px 8px",
                                    cursor: "pointer",
                                    fontSize: "13px",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis"
                                  }}
                                >
                                  <input
                                    type="checkbox"
                                    checked={SelectedDistrict.includes(district)}
                                    onChange={() => handleDistrictToggle(district)}
                                    style={{ marginRight: "6px" }}
                                  />

                                  {district}
                                </label>
                              ))}
                            </div>

                            {/* OK button */}
                            <div
                              style={{
                                borderTop: "1px solid #eee",
                                padding: "6px",
                                textAlign: "right"
                              }}
                            >
                              <button
                                onClick={() => setOpenDistrict(false)}
                                style={{
                                  padding: "4px 10px",
                                  fontSize: "12px",
                                  borderRadius: "6px",
                                  border: "none",
                                  background: "#0d6efd",
                                  color: "#fff",
                                  cursor: "pointer"
                                }}
                              >
                                OK
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    )}

                  {/* Taluka */}
                  <div style={filterWrapperStyle}>
                    <select
                      value={SelectedTalukasofDistrict}
                      onChange={(e) =>
                        setSelectedTalukasofDistrict(e.target.value)
                      }
                      style={filterStyle}
                    >
                      {/* <option value="">
                        {t("Select Taluka")}
                      </option>

                      {TalukasofDistrict?.map((val, index) => (
                        <option
                          key={index}
                          value={val.ULBNameMarathi || val.Taluka}
                        >
                          {val.ULBNameMarathi || val.Taluka}
                        </option>
                      ))} */}
                                           {/* /////////////////////Addeddd */}
                                          <option value="">{t("Select Taluka")}</option>

                                          {uniqueTalukas.map((taluka) => (
                                              <option key={taluka} value={taluka}>
                                                  {taluka}
                                              </option>
                                          ))}
                    </select>
                  </div>

                  {/* Search */}
                  <div style={filterWrapperStyle}>
                    <img
                      src="/Search32.png"
                      alt="Search"
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "10px",
                        transform: "translateY(-50%)",
                        width: "16px",
                        opacity: 0.6,
                        zIndex: 1
                      }}
                    />

                    <input
                      type="text"
                      placeholder={t("Search")}
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      style={{
                        ...filterStyle,
                        padding: "8px 12px 8px 32px",
                        backgroundColor: "#f1f6fc"
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="col-12 pb-5">
                <div
                  className="m-auto mb-3"
                  style={{
                    backgroundColor: "white",
                    padding: "40px 40px",
                    boxShadow: "0px 0px 5px 1px #E4E8EC",
                    borderRadius: "20px",
                    width: "100%",
                    maxWidth: "100%",
                    overflowX: "hidden",
                  }}
                >
                  <div
                    className="col-12 tableDesign"
                    style={{
                      background: "#2C78DB", overflowX: "auto",
                      overflowY: "auto",
                      maxHeight: "600px", // change height as needed
                      position: "relative",
                    }}
                  >
                    {typeofData == "District" &&
                      HeadcodeRole !== "State-Deputy Secretary" && (
                        <table
                          className="m-0 p-0 ALlDistrictFinanceData Proposaloutward"
                          style={{ width: "100%", borderCollapse: "collapse" }}
                        >
                          <thead style={{
                            position: "sticky", backgroundColor: "#1976d2",
                            top: 0,
                            zIndex: 10,
                          }}>
                            <tr
                              style={{
                                color: "white",
                                border: "none",
                                height: "3rem",
                                fontSize: "18px",
                              }}
                            >
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "60px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Sr.No")}
                              </th>
                              {typeofData === "District" &&
                                HeadcodeRole !== "State-Deputy Secretary" &&
                                [24, 25, 32, 33,40,41].includes(RoleID) ? (
                                ""
                              ) : (
                                <th
                                  style={{
                                    padding: "7px 10px",
                                    minWidth: "250px",
                                  }}
                                  rowSpan={2}
                                  colSpan={1}
                                >
                                  {t("Head Code")}
                                </th>
                              )}
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "110px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Year")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "230px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Work Name")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "200px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Job ID")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "120px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("District")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "120px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Taluka")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "200px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Gram Panchayat")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "150px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Constituency Name")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "150px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Proposal File Number")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "140px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Work Amount")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "130px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Class Of Work")}
                              </th>
                              {/* <th style={{ padding: "7px 10px", minWidth: "250px" }} rowSpan={2} colSpan={1}>{t("Proposal Copy")}</th> */}
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "250px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Additional Support Document")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "150px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Creation Date")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "150px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Edited By")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "150px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("SendBack/Rejected")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "150px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Remark(if any)")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "150px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Updated Field(if any)")}
                              </th>
                              <th style={{ padding: "7px 10px" }} colSpan={3}>
                                {t("Approved by")}
                              </th>
                            </tr>

                            <tr
                              style={{
                                width: "100%",
                                color: "white",
                                border: "none",
                                height: "3rem",
                                fontSize: "18px",
                                fontWeight: "400",
                              }}
                            >
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "160px",
                                }}
                              >
                                {t("Deputy Engineer")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "160px",
                                }}
                              >
                                {t("Department HOD(EE)")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "160px",
                                }}
                              >
                                {t("Additional CEO")}
                              </th>
                            </tr>
                          </thead>

                          <tbody>
                            <>
                              {displayedGRS?.length === 0 ? (
                                <tr>
                                  <td
                                    colSpan="20"
                                    style={{
                                      textAlign: "center",
                                      padding: "10px",
                                      backgroundColor: "#f9f9f9",
                                    }}
                                  >
                                    {t("No data available")}
                                  </td>
                                </tr>
                              ) : (
                                displayedGRS?.map((proposal, index) => {
                                  const bgColor =
                                    index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";

                                  return (
                                    <tr
                                      key={index}
                                      style={{
                                        backgroundColor: bgColor,
                                        fontSize: "18px",
                                        fontWeight: "400",
                                      }}
                                    >
                                      <td style={{ padding: "8px 8px" }}>
                                        {(currentPage - 1) * billsPerPage +
                                          index +
                                          1}
                                      </td>
                                      {typeofData === "District" &&
                                        HeadcodeRole !==
                                        "State-Deputy Secretary" &&
                                        [24, 25, 32, 33,40,41].includes(RoleID) ? (
                                        ""
                                      ) : (
                                        <td style={{ padding: "8px 8px" }}>
                                          {proposal.HeadCode}
                                        </td>
                                      )}
                                      <td style={{ padding: "8px 8px" }}>
                                        {proposal.Proposal_year}
                                      </td>
                                      <td style={{ padding: "8px 8px" }}>
                                        {proposal.Work_name}
                                      </td>
                                      <td style={{ padding: "8px 8px" }}>
                                        {proposal.JOB_ID}
                                      </td>
                                      <td style={{ padding: "8px 8px" }}>
                                        {proposal.District}
                                      </td>
                                      <td style={{ padding: "8px 8px" }}>
                                        {proposal.Taluka}
                                      </td>
                                      <td style={{ padding: "8px 8px" }}>
                                        {JSON.parse(
                                          proposal.Gram_panchayat,
                                        ).join(", ")}
                                      </td>
                                      <td style={{ padding: "8px 8px" }}>
                                        {proposal.Constituency_name}
                                      </td>
                                      <td style={{ padding: "8px 8px" }}>
                                        {proposal.Proposal_fileNumber}
                                      </td>
                                      <td style={{ padding: "8px 8px" }}>
                                        {/* {proposal.Proposal_amount} */}
                                        {Number(proposal.Proposal_amount || 0).toLocaleString("en-IN")}
                                      </td>
                                      <td style={{ padding: "8px 8px" }}>
                                        {proposal.classOfWork}
                                      </td>
                                      {/* <td style={{ padding: '8px 8px' }}>{
                                                                                proposal.Proposal_copy ? (
                                                                                    <span
                                                                                        onClick={(e) => {
                                                                                            e.preventDefault();
                                                                                            SecureFileFetching(`ProposalFile/${proposal.Proposal_copy}`);
                                                                                        }}
                                                                                        // href={`${apiurl}/ProposalFile/${proposal.Proposal_copy}`}
                                                                                        className='text-primary'
                                                                                        style={{ cursor: "pointer" }}
                                                                                    >
                                                                                        {proposal.Proposal_copy}
                                                                                    </span>
                                                                                )
                                                                                    :
                                                                                    (
                                                                                        <p className='fw-bold text-danger my-auto'>{t("No File")}</p>
                                                                                    )
                                                                            }
                                                                            </td> */}

                                      <td style={{ padding: "8px 8px" }}>
                                        {proposal.Additional_suppDoc ? (
                                          <span
                                            href={`${apiurl}/ProposalFile/${proposal.Additional_suppDoc}`}
                                            target='_blank'
                                            onClick={(e) => {
                                              e.preventDefault();
                                              SecureFileFetching(
                                                `ProposalFile/${proposal.Additional_suppDoc}`,
                                              );
                                            }}
                                            className="text-primary"
                                            style={{ cursor: "pointer" }}
                                          >
                                            {proposal.Additional_suppDoc}
                                          </span>
                                        ) : (
                                          <p className="fw-bold text-danger my-auto">
                                            {t("No File")}
                                          </p>
                                        )}
                                      </td>
                                      <td style={{ padding: "8px 8px" }}>
                                        {formatDateTime(
                                          proposal.created_at,
                                        )}
                                      </td>
                                      <td style={{ padding: "8px 8px" }}>
                                        {proposal.EditedBy ? (
                                          <p className="text-black my-auto fw-bold">
                                            {proposal.EditedBy}
                                          </p>
                                        ) : (
                                          <p className="text-danger my-auto fw-bold">
                                            {t("No One")}
                                          </p>
                                        )}
                                      </td>
                                      <td style={{ padding: "8px 8px" }}>
                                        {proposal.Status == "Pending"
                                          ? "-"
                                          : proposal.Status}
                                      </td>
                                      {/* <td style={{ padding: "8px 8px" }}>
                                        {proposal.Remark || "NA"}
                                      </td> */}
<td
    className="py-2"
    style={{ padding: "12px 15px" }}
>
    {proposal.Remark?.trim() &&
     proposal.Remark.trim().toUpperCase() !== "NA"
        ? proposal.Remark
        : proposal.workRemark?.trim()
            ? proposal.workRemark
            : "N/A"}
</td>
                                      <td style={{ padding: "8px 8px" }}>
                                        {proposal.updatedFieldsStr || "NA"}
                                      </td>

                                      <td
                                        style={{
                                          padding: "8px",
                                          textAlign: "center",
                                        }}
                                      >
                                        {proposal.Approvance1 === "true" ? (
                                          <div
                                            className="m-auto"
                                            style={{
                                              width: "20px",
                                              height: "20px",
                                              borderRadius: "6px",
                                              backgroundColor: "#16C60C",
                                              border: "none",
                                              display: "flex",
                                              justifyContent: "center",
                                              alignItems: "center",
                                              fontSize: "13px",
                                              color: "white",
                                              boxShadow:
                                                "0 2px 4px rgba(0,0,0,0.1)",
                                            }}
                                          >
                                            ✓
                                          </div>
                                        ) : proposal.Approvance1 === "false" ? (
                                          <div
                                            className="m-auto"
                                            style={{
                                              width: "20px",
                                              height: "20px",
                                              borderRadius: "6px",
                                              backgroundColor: "#dc2626",
                                              border: "none",
                                              display: "flex",
                                              justifyContent: "center",
                                              alignItems: "center",
                                              fontSize: "13px",
                                              color: "white",
                                              boxShadow:
                                                "0 2px 4px rgba(0,0,0,0.1)",
                                            }}
                                          >
                                            ✕
                                          </div>
                                        ) : (
                                          "-"
                                        )}
                                      </td>
                                      <td
                                        style={{
                                          padding: "8px",
                                          textAlign: "center",
                                        }}
                                      >
                                        {proposal.Approvance2 === "true" ? (
                                          <div
                                            className="m-auto"
                                            style={{
                                              width: "20px",
                                              height: "20px",
                                              borderRadius: "6px",
                                              backgroundColor: "#16C60C",
                                              border: "none",
                                              display: "flex",
                                              justifyContent: "center",
                                              alignItems: "center",
                                              fontSize: "13px",
                                              color: "white",
                                              boxShadow:
                                                "0 2px 4px rgba(0,0,0,0.1)",
                                            }}
                                          >
                                            ✓
                                          </div>
                                        ) : proposal.Approvance2 === "false" ? (
                                          <div
                                            className="m-auto"
                                            style={{
                                              width: "20px",
                                              height: "20px",
                                              borderRadius: "6px",
                                              backgroundColor: "#dc2626",
                                              border: "none",
                                              display: "flex",
                                              justifyContent: "center",
                                              alignItems: "center",
                                              fontSize: "13px",
                                              color: "white",
                                              boxShadow:
                                                "0 2px 4px rgba(0,0,0,0.1)",
                                            }}
                                          >
                                            ✕
                                          </div>
                                        ) : (
                                          "-"
                                        )}
                                      </td>
                                      <td
                                        style={{
                                          padding: "8px",
                                          textAlign: "center",
                                        }}
                                      >
                                        {proposal.Approvance3 === "true" ? (
                                          <div
                                            className="m-auto"
                                            style={{
                                              width: "20px",
                                              height: "20px",
                                              borderRadius: "6px",
                                              backgroundColor: "#16C60C",
                                              border: "none",
                                              display: "flex",
                                              justifyContent: "center",
                                              alignItems: "center",
                                              fontSize: "13px",
                                              color: "white",
                                              boxShadow:
                                                "0 2px 4px rgba(0,0,0,0.1)",
                                            }}
                                          >
                                            ✓
                                          </div>
                                        ) : proposal.Approvance3 === "false" ? (
                                          <div
                                            className="m-auto"
                                            style={{
                                              width: "20px",
                                              height: "20px",
                                              borderRadius: "6px",
                                              backgroundColor: "#dc2626",
                                              border: "none",
                                              display: "flex",
                                              justifyContent: "center",
                                              alignItems: "center",
                                              fontSize: "13px",
                                              color: "white",
                                              boxShadow:
                                                "0 2px 4px rgba(0,0,0,0.1)",
                                            }}
                                          >
                                            ✕
                                          </div>
                                        ) : (
                                          "-"
                                        )}
                                      </td>
                                    </tr>
                                  );
                                })
                              )}
                              <tr
                                style={{
                                  fontWeight: "600",
                                  backgroundColor: "#f0f0f0",
                                  fontSize: "18px",
                                }}
                              >
                                <td colSpan={typeofData == "District" &&
                                  (HeadcodeRole !== "State-Deputy Secretary" && [24, 25, 32, 33,40,41].includes(RoleID)) ? 9 : 10} style={{ textAlign: "right", padding: "8px" }}>
                                  {t("Page Total")}
                                </td>

                                <td style={{ padding: "8px" }}  >
                                  ₹ {pageProposalAmount.toLocaleString("en-IN")}
                                </td>

                                {/* remaining columns */}
                                <td colSpan={typeofData == "District" &&
                                  (HeadcodeRole !== "State-Deputy Secretary" && [24, 25, 32, 33,40,41].includes(RoleID)) ? 19 : 20}></td>
                              </tr>
                              <tr
                                style={{
                                  fontWeight: "600",
                                  backgroundColor: "#f0f0f0",
                                  fontSize: "18px",
                                }}
                              >
                                <td colSpan={typeofData == "District" &&
                                  (HeadcodeRole !== "State-Deputy Secretary" && [24, 25, 32, 33,40,41].includes(RoleID)) ? 9 : 10} style={{ textAlign: "right", padding: "8px" }}>
                                  {t("Gross Total")}
                                </td>

                                <td style={{ padding: "8px" }}>
                                  ₹{" "}
                                  {totalProposalAmount.toLocaleString("en-IN")}
                                </td>

                                {/* remaining columns */}
                                <td
                                  colSpan={
                                    typeofData == "District" &&
                                      HeadcodeRole !== "State-Deputy Secretary" &&
                                      [24, 25, 32, 33,40,41].includes(RoleID)
                                      ? 19
                                      : 20
                                  }
                                ></td>
                              </tr>
                            </>
                          </tbody>
                        </table>
                      )}
                    {typeofData == "District" &&
                      HeadcodeRole == "State-Deputy Secretary" && (
                        <table
                          className="m-0 p-0 ALlDistrictFinanceData Proposaloutward"
                          style={{ width: "100%", borderCollapse: "collapse" }}
                        >
                          <thead>
                            <tr
                              style={{
                                color: "white",
                                border: "none",
                                height: "3rem",
                                fontSize: "18px",
                              }}
                            >
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "60px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Sr.No")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "250px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Head Code")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "110px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Year")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "230px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Work Name")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "200px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Job ID")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "120px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("District")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "120px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Taluka")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "200px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Gram Panchayat")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "150px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Constituency Name")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "150px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Proposal File Number")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "130px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Work Amount")}
                              </th>
                              {/* <th style={{ padding: "7px 10px", minWidth: "250px" }} rowSpan={2} colSpan={1}>{t("Proposal Copy")}</th> */}
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "250px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Additional Support Document")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "150px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Creation Date")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "150px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Edited By")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "150px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("SendBack/Rejected")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "150px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Remark(if any)")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "150px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Updated Field(if any)")}
                              </th>
                              <th style={{ padding: "7px 10px" }} colSpan={3}>
                                {t("Approved by")}
                              </th>
                            </tr>

                            <tr
                              style={{
                                width: "100%",
                                color: "white",
                                border: "none",
                                height: "3rem",
                                fontSize: "18px",
                                fontWeight: "400",
                              }}
                            >
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "160px",
                                }}
                              >
                                {t("Deputy Engineer")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "160px",
                                }}
                              >
                                {t("Department HOD(EE)")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "160px",
                                }}
                              >
                                {t("Additional CEO")}
                              </th>
                            </tr>
                          </thead>

                          <tbody>
                            <>
                              {displayedGRS?.length === 0 ? (
                                <tr>
                                  <td
                                    colSpan="20"
                                    style={{
                                      textAlign: "center",
                                      padding: "10px",
                                      backgroundColor: "#f9f9f9",
                                    }}
                                  >
                                    {t("No data available")}
                                  </td>
                                </tr>
                              ) : (
                                displayedGRS?.map((proposal, index) => {
                                  const bgColor =
                                    index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";

                                  return (
                                    <tr
                                      key={index}
                                      style={{
                                        backgroundColor: bgColor,
                                        fontSize: "18px",
                                        fontWeight: "400",
                                      }}
                                    >
                                      <td style={{ padding: "8px 8px" }}>
                                        {(currentPage - 1) * billsPerPage +
                                          index +
                                          1}
                                      </td>
                                      <td style={{ padding: "8px 8px" }}>
                                        {proposal.HeadCode}
                                      </td>
                                      <td style={{ padding: "8px 8px" }}>
                                        {proposal.Proposal_year}
                                      </td>
                                      <td style={{ padding: "8px 8px" }}>
                                        {proposal.Work_name}
                                      </td>
                                      <td style={{ padding: "8px 8px" }}>
                                        {proposal.JOB_ID}
                                      </td>
                                      <td style={{ padding: "8px 8px" }}>
                                        {proposal.District}
                                      </td>
                                      <td style={{ padding: "8px 8px" }}>
                                        {proposal.Taluka}
                                      </td>
                                      <td style={{ padding: "8px 8px" }}>
                                        {JSON.parse(
                                          proposal.Gram_panchayat,
                                        ).join(", ")}
                                      </td>
                                      <td style={{ padding: "8px 8px" }}>
                                        {proposal.Constituency_name}
                                      </td>
                                      <td style={{ padding: "8px 8px" }}>
                                        {proposal.Proposal_fileNumber}
                                      </td>
                                      <td style={{ padding: "8px 8px" }}>
                                        {/* {proposal.Proposal_amount} */}
                                        {Number(proposal.Proposal_amount || 0).toLocaleString("en-IN")}
                                      </td>
                                      {/* <td style={{ padding: '8px 8px' }}>{
                                                                        proposal.Proposal_copy ? (
                                                                            <span
                                                                                onClick={(e) => {
                                                                                    e.preventDefault();
                                                                                    SecureFileFetching(`ProposalFile/${proposal.Proposal_copy}`);
                                                                                }}
                                                                                // href={`${apiurl}/ProposalFile/${proposal.Proposal_copy}`}
                                                                                className='text-primary'
                                                                                style={{ cursor: "pointer" }}
                                                                            >
                                                                                {proposal.Proposal_copy}
                                                                            </span>
                                                                        )
                                                                            :
                                                                            (
                                                                                <p className='fw-bold text-danger my-auto'>{t("No File")}</p>
                                                                            )
                                                                    }
                                                                    </td> */}

                                      <td style={{ padding: "8px 8px" }}>
                                        {proposal.Proposal_copy ? (
                                          <span
                                            onClick={(e) => {
                                              e.preventDefault();
                                              SecureFileFetching(
                                                `ProposalFile/${proposal.Proposal_copy}`,
                                              );
                                            }}
                                            // href={`${apiurl}/ProposalFile/${proposal.Proposal_copy}`}
                                            className="text-primary"
                                            style={{ cursor: "pointer" }}
                                          >
                                            {proposal.Proposal_copy}
                                          </span>
                                        ) : (
                                          <p className="fw-bold text-danger my-auto">
                                            {t("No File")}
                                          </p>
                                        )}
                                      </td>
                                      <td style={{ padding: "8px 8px" }}>
                                        {formatDateTime(
                                          proposal.created_at,
                                        )}
                                      </td>
                                      <td style={{ padding: "8px 8px" }}>
                                        {proposal.EditedBy ? (
                                          <p className="text-black my-auto fw-bold">
                                            {proposal.EditedBy}
                                          </p>
                                        ) : (
                                          <p className="text-danger my-auto fw-bold">
                                            {t("No One")}
                                          </p>
                                        )}
                                      </td>
                                      <td style={{ padding: "8px 8px" }}>
                                        {proposal.Status == "Pending"
                                          ? "-"
                                          : proposal.Status}
                                      </td>
                                      {/* <td style={{ padding: "8px 8px" }}>
                                        {proposal.Remark || "NA"}
                                      </td> */}
<td
    className="py-2"
    style={{ padding: "12px 15px" }}
>
    {proposal.Remark?.trim() &&
     proposal.Remark.trim().toUpperCase() !== "NA"
        ? proposal.Remark
        : proposal.workRemark?.trim()
            ? proposal.workRemark
            : "N/A"}
</td>
                                      <td style={{ padding: "8px 8px" }}>
                                        {proposal.updatedFieldsStr || "NA"}
                                      </td>

                                      <td
                                        style={{
                                          padding: "8px",
                                          textAlign: "center",
                                        }}
                                      >
                                        {proposal.Approvance1 === "true" ? (
                                          <div
                                            className="m-auto"
                                            style={{
                                              width: "20px",
                                              height: "20px",
                                              borderRadius: "6px",
                                              backgroundColor: "#16C60C",
                                              border: "none",
                                              display: "flex",
                                              justifyContent: "center",
                                              alignItems: "center",
                                              fontSize: "13px",
                                              color: "white",
                                              boxShadow:
                                                "0 2px 4px rgba(0,0,0,0.1)",
                                            }}
                                          >
                                            ✓
                                          </div>
                                        ) : proposal.Approvance1 === "false" ? (
                                          <div
                                            className="m-auto"
                                            style={{
                                              width: "20px",
                                              height: "20px",
                                              borderRadius: "6px",
                                              backgroundColor: "#dc2626",
                                              border: "none",
                                              display: "flex",
                                              justifyContent: "center",
                                              alignItems: "center",
                                              fontSize: "13px",
                                              color: "white",
                                              boxShadow:
                                                "0 2px 4px rgba(0,0,0,0.1)",
                                            }}
                                          >
                                            ✕
                                          </div>
                                        ) : (
                                          "-"
                                        )}
                                      </td>
                                      <td
                                        style={{
                                          padding: "8px",
                                          textAlign: "center",
                                        }}
                                      >
                                        {proposal.Approvance2 === "true" ? (
                                          <div
                                            className="m-auto"
                                            style={{
                                              width: "20px",
                                              height: "20px",
                                              borderRadius: "6px",
                                              backgroundColor: "#16C60C",
                                              border: "none",
                                              display: "flex",
                                              justifyContent: "center",
                                              alignItems: "center",
                                              fontSize: "13px",
                                              color: "white",
                                              boxShadow:
                                                "0 2px 4px rgba(0,0,0,0.1)",
                                            }}
                                          >
                                            ✓
                                          </div>
                                        ) : proposal.Approvance2 === "false" ? (
                                          <div
                                            className="m-auto"
                                            style={{
                                              width: "20px",
                                              height: "20px",
                                              borderRadius: "6px",
                                              backgroundColor: "#dc2626",
                                              border: "none",
                                              display: "flex",
                                              justifyContent: "center",
                                              alignItems: "center",
                                              fontSize: "13px",
                                              color: "white",
                                              boxShadow:
                                                "0 2px 4px rgba(0,0,0,0.1)",
                                            }}
                                          >
                                            ✕
                                          </div>
                                        ) : (
                                          "-"
                                        )}
                                      </td>
                                      <td
                                        style={{
                                          padding: "8px",
                                          textAlign: "center",
                                        }}
                                      >
                                        {proposal.Approvance3 === "true" ? (
                                          <div
                                            className="m-auto"
                                            style={{
                                              width: "20px",
                                              height: "20px",
                                              borderRadius: "6px",
                                              backgroundColor: "#16C60C",
                                              border: "none",
                                              display: "flex",
                                              justifyContent: "center",
                                              alignItems: "center",
                                              fontSize: "13px",
                                              color: "white",
                                              boxShadow:
                                                "0 2px 4px rgba(0,0,0,0.1)",
                                            }}
                                          >
                                            ✓
                                          </div>
                                        ) : proposal.Approvance3 === "false" ? (
                                          <div
                                            className="m-auto"
                                            style={{
                                              width: "20px",
                                              height: "20px",
                                              borderRadius: "6px",
                                              backgroundColor: "#dc2626",
                                              border: "none",
                                              display: "flex",
                                              justifyContent: "center",
                                              alignItems: "center",
                                              fontSize: "13px",
                                              color: "white",
                                              boxShadow:
                                                "0 2px 4px rgba(0,0,0,0.1)",
                                            }}
                                          >
                                            ✕
                                          </div>
                                        ) : (
                                          "-"
                                        )}
                                      </td>
                                    </tr>
                                  );
                                })
                              )}
                              <tr
                                style={{
                                  fontWeight: "600",
                                  backgroundColor: "#f0f0f0",
                                  fontSize: "18px",
                                }}
                              >
                                <td colSpan={typeofData == "District" &&
                                  (HeadcodeRole !== "State-Deputy Secretary" && [24, 25, 32, 33,40,41].includes(RoleID)) ? 9 : 10} style={{ textAlign: "right", padding: "8px" }}>
                                  {t("Page Total")}
                                </td>

                                <td style={{ padding: "8px" }}  >
                                  ₹ {pageProposalAmount.toLocaleString("en-IN")}
                                </td>

                                {/* remaining columns */}
                                <td colSpan={typeofData == "District" &&
                                  (HeadcodeRole !== "State-Deputy Secretary" && [24, 25, 32, 33,40,41].includes(RoleID)) ? 19 : 20}></td>
                              </tr>
                              <tr
                                style={{
                                  fontWeight: "600",
                                  backgroundColor: "#f0f0f0",
                                  fontSize: "18px",

                                }}
                              >
                                <td colSpan={typeofData == "District" &&
                                  (HeadcodeRole !== "State-Deputy Secretary" && [24, 25, 32, 33,40,41].includes(RoleID)) ? 9 : 10} style={{ textAlign: "right", padding: "8px" }}>
                                  {t("Gross Total")}
                                </td>

                                <td style={{ padding: "8px" }}  >
                                  ₹ {totalProposalAmount.toLocaleString("en-IN")}
                                </td>

                                {/* remaining columns */}
                                <td colSpan={typeofData == "District" &&
                                  (HeadcodeRole !== "State-Deputy Secretary" && [24, 25, 32, 33,40,41].includes(RoleID)) ? 19 : 20}></td>
                              </tr>
                            </>
                          </tbody>
                        </table>
                      )}

                    {typeofData == "State" &&
                      HeadcodeRole !== "State-Deputy Secretary" && (
                        <table
                          className="m-0 p-0 ALlDistrictFinanceData Proposaloutward"
                          style={{ width: "100%", borderCollapse: "collapse" }}
                        >
                          <thead>
                            <tr
                              style={{
                                color: "white",
                                border: "none",
                                height: "3rem",
                                fontSize: "18px",
                              }}
                            >
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "60px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Sr.No ")}
                              </th>
                              {typeofData === "State" &&
                                HeadcodeRole !== "State-Deputy Secretary" ? (
                                ""
                              ) : (
                                <th
                                  style={{
                                    padding: "7px 10px",
                                    minWidth: "200px",
                                  }}
                                  rowSpan={2}
                                  colSpan={1}
                                >
                                  {t("Head Code")}
                                </th>
                              )}{" "}
                              {/* changed from 9 to 7 */}
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "110px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Proposal Year")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "230px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Work Name")}
                              </th>
                              {userData?.RoleID !== 41 && (
                                <th
                                  style={{
                                    padding: "7px 10px",
                                    minWidth: "200px",
                                  }}
                                  rowSpan={2}
                                  colSpan={1}
                                >
                                  {t("Job ID")}
                                </th>
                              )}
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "120px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("District")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "120px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Taluka")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "200px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Gram Panchayat")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "150px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Constituency Name")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "150px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Proposal File Number")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "130px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Work Amount")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "130px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Class Of Work")}
                              </th>
                              {/* <th style={{ padding: "7px 10px", minWidth: "250px" }} rowSpan={2} colSpan={1}>{t("Proposal Copy")}</th> */}
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "250px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Additional Support Document")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "150px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Creation Date")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "150px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Edited By")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "150px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("SendBack/Rejected")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "150px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Updated Field(if any)")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "150px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Remark(if any)")}
                              </th>
                              {/* <th style={{ minWidth: "150px", padding: "8px" }}rowSpan={2} colSpan={1}>View Approvals</th> */}
                              <th style={{ padding: "7px 10px" }} colSpan={2}>
                                {t("Approved by")}
                              </th>{" "}
                              {/* changed from 9 to 7 */}
                            </tr>

                            <tr
                              style={{
                                width: "100%",
                                color: "white",
                                border: "none",
                                height: "3rem",
                                fontSize: "18px",
                                fontWeight: "400",
                              }}
                            >
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "160px",
                                }}
                              >
                                {t("RDD Section Officer")}
                              </th>
                              {/* <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "160px",
                                }}
                              >
                                {t("Deputy Secretary")}
                              </th> */}
                            </tr>
                          </thead>

                          <tbody>
                            <>
                              {displayedGRS?.length === 0 ? (
                                <tr>
                                  <td
                                    colSpan="30"
                                    style={{
                                      textAlign: "center",
                                      padding: "10px",
                                      backgroundColor: "#f9f9f9",
                                    }}
                                  >
                                    {t("No data available")}
                                  </td>
                                </tr>
                              ) : (
                                displayedGRS?.map((proposal, index) => {
                                  const bgColor =
                                    index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";

                                  return (
                                    <>
                                      <tr
                                        key={index}
                                        style={{
                                          backgroundColor: bgColor,
                                          fontSize: "18px",
                                          fontWeight: "400",
                                        }}
                                      >
                                        <td style={{ padding: "8px 8px" }}>
                                          {(currentPage - 1) * billsPerPage +
                                            index +
                                            1}
                                        </td>
                                        {typeofData === "State" &&
                                          HeadcodeRole !==
                                          "State-Deputy Secretary" ? (
                                          ""
                                        ) : (
                                          <td style={{ padding: "8px 8px" }}>
                                            {proposal.HeadCode}
                                          </td>
                                        )}
                                        <td style={{ padding: "8px 8px" }}>
                                          {proposal.Proposal_year}
                                        </td>
                                        <td style={{ padding: "8px 8px" }}>
                                          {proposal.Work_name}
                                        </td>
                                        {userData?.RoleID !== 41 && (
                                          <td style={{ padding: "8px 8px" }}>
                                            {proposal.JOB_ID}
                                          </td>
                                        )}
                                        <td style={{ padding: "8px 8px" }}>
                                          {proposal.District}
                                        </td>
                                        <td style={{ padding: "8px 8px" }}>
                                          {proposal.Taluka}
                                        </td>
                                        <td style={{ padding: "8px 8px" }}>
                                          {JSON.parse(
                                            proposal.Gram_panchayat,
                                          ).join(", ")}
                                        </td>
                                        <td style={{ padding: "8px 8px" }}>
                                          {proposal.Constituency_name}
                                        </td>
                                        <td style={{ padding: "8px 8px" }}>
                                          {proposal.Proposal_fileNumber}
                                        </td>
                                        <td style={{ padding: "8px 8px" }}>
                                          {/* {proposal.Proposal_amount} */}
                                          {Number(proposal.Proposal_amount || 0).toLocaleString("en-IN")}
                                        </td>
                                        <td style={{ padding: "8px 8px" }}>
                                          {proposal.classOfWork}
                                        </td>
                                        {/* <td style={{ padding: '8px 8px' }}>{
                                                                                    proposal.Proposal_copy ? (
                                                                                        <span
                                                                                            onClick={(e) => {
                                                                                                e.preventDefault();
                                                                                                SecureFileFetching(`ProposalFile/${proposal.Proposal_copy}`);
                                                                                            }}
                                                                                            // href={`${apiurl}/ProposalFile/${proposal.Proposal_copy}`}
                                                                                            className='text-primary'
                                                                                            style={{ cursor: "pointer" }}
                                                                                        >
                                                                                            {proposal.Proposal_copy}
                                                                                        </span>
                                                                                    )
                                                                                        :
                                                                                        (
                                                                                            <p className='fw-bold text-danger my-auto'>{t("No File")}</p>
                                                                                        )
                                                                                }
                                                                                </td> */}

                                        <td style={{ padding: "8px 8px" }}>
                                          {proposal.Proposal_copy ? (
                                            <span
                                              onClick={(e) => {
                                                e.preventDefault();
                                                SecureFileFetching(
                                                  `ProposalFile/${proposal.Proposal_copy}`,
                                                );
                                              }}
                                              // href={`${apiurl}/ProposalFile/${proposal.Proposal_copy}`}
                                              className="text-primary"
                                              style={{ cursor: "pointer" }}
                                            >
                                              {proposal.Proposal_copy}
                                            </span>
                                          ) : (
                                            <p className="fw-bold text-danger my-auto">
                                              {t("No File")}
                                            </p>
                                          )}
                                        </td>
                                        <td style={{ padding: "8px 8px" }}>
                                         {formatDateTime(
                                          proposal.created_at,
                                        )}
                                        </td>
                                        <td style={{ padding: "8px 8px" }}>
                                          {proposal.EditedBy ? (
                                            <p className="text-black my-auto fw-bold">
                                              {proposal.EditedBy}
                                            </p>
                                          ) : (
                                            <p className="text-danger my-auto fw-bold">
                                              {t("No One")}
                                            </p>
                                          )}
                                        </td>

                                        <td style={{ padding: "8px 8px" }}>
                                          {proposal.Status == "Pending"
                                            ? "-"
                                            : proposal.Status}
                                        </td>
                                        <td style={{ padding: "8px 8px" }}>
                                          {proposal.updatedFieldsStr || "NA"}
                                        </td>
                                        {/* <td style={{ padding: "8px 8px" }}>
                                          {proposal.Remark || "NA"}
                                        </td> */}
<td
    className="py-2"
    style={{ padding: "12px 15px" }}
>
    {proposal.Remark?.trim() &&
     proposal.Remark.trim().toUpperCase() !== "NA"
        ? proposal.Remark
        : proposal.workRemark?.trim()
            ? proposal.workRemark
            : "N/A"}
</td>

                                        <td
                                          style={{
                                            padding: "8px",
                                            textAlign: "center",
                                          }}
                                        >
                                          {proposal.Approvance5 === "true" ? (
                                            <div
                                              className="m-auto"
                                              style={{
                                                width: "20px",
                                                height: "20px",
                                                borderRadius: "6px",
                                                backgroundColor: "#16C60C",
                                                border: "none",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                fontSize: "13px",
                                                color: "white",
                                                boxShadow:
                                                  "0 2px 4px rgba(0,0,0,0.1)",
                                              }}
                                            >
                                              ✓
                                            </div>
                                          ) : proposal.Approvance5 ===
                                            "false" ? (
                                            <div
                                              className="m-auto"
                                              style={{
                                                width: "20px",
                                                height: "20px",
                                                borderRadius: "6px",
                                                backgroundColor: "#dc2626",
                                                border: "none",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                fontSize: "13px",
                                                color: "white",
                                                boxShadow:
                                                  "0 2px 4px rgba(0,0,0,0.1)",
                                              }}
                                            >
                                              ✕
                                            </div>
                                          ) : (
                                            "-"
                                          )}
                                        </td>
                                        {/* <td
                                          style={{
                                            padding: "8px",
                                            textAlign: "center",
                                          }}
                                        >
                                          {proposal.Approvance6 === "true" ? (
                                            <div
                                              className="m-auto"
                                              style={{
                                                width: "20px",
                                                height: "20px",
                                                borderRadius: "6px",
                                                backgroundColor: "#16C60C",
                                                border: "none",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                fontSize: "13px",
                                                color: "white",
                                                boxShadow:
                                                  "0 2px 4px rgba(0,0,0,0.1)",
                                              }}
                                            >
                                              ✓
                                            </div>
                                          ) : proposal.Approvance6 ===
                                            "false" ? (
                                            <div
                                              className="m-auto"
                                              style={{
                                                width: "20px",
                                                height: "20px",
                                                borderRadius: "6px",
                                                backgroundColor: "#dc2626",
                                                border: "none",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                fontSize: "13px",
                                                color: "white",
                                                boxShadow:
                                                  "0 2px 4px rgba(0,0,0,0.1)",
                                              }}
                                            >
                                              ✕
                                            </div>
                                          ) : (
                                            "-"
                                          )}
                                        </td> */}
                                      </tr>
                                    </>
                                  );
                                })
                              )}
                              <tr
                                style={{
                                  fontWeight: "600",
                                  backgroundColor: "#f0f0f0",
                                  fontSize: "18px",
                                }}
                              >
                                <td colSpan={typeofData == "District" &&
                                  (HeadcodeRole !== "State-Deputy Secretary" && [24, 25, 32, 33,40,41].includes(RoleID)) ? 9 : 10} style={{ textAlign: "right", padding: "8px" }}>
                                  {t("Page Total")}
                                </td>

                                <td style={{ padding: "8px" }}  >
                                  ₹ {pageProposalAmount.toLocaleString("en-IN")}
                                </td>

                                {/* remaining columns */}
                                <td colSpan={typeofData == "District" &&
                                  (HeadcodeRole !== "State-Deputy Secretary" && [24, 25, 32, 33,40,41].includes(RoleID)) ? 19 : 20}></td>
                              </tr>
                              <tr
                                style={{
                                  fontWeight: "600",
                                  backgroundColor: "#f0f0f0",
                                  fontSize: "18px",

                                }}
                              >
                                <td colSpan={typeofData == "District" &&
                                  (HeadcodeRole !== "State-Deputy Secretary" && [24, 25, 32, 33,40,41].includes(RoleID)) ? 9 : 10} style={{ textAlign: "right", padding: "8px" }}>
                                  {t("Gross Total")}
                                </td>

                                <td style={{ padding: "8px" }}  >
                                  ₹ {totalProposalAmount.toLocaleString("en-IN")}
                                </td>

                                {/* remaining columns */}
                                <td colSpan={typeofData == "District" &&
                                  (HeadcodeRole !== "State-Deputy Secretary" && [24, 25, 32, 33,40,41].includes(RoleID)) ? 19 : 20}></td>
                              </tr>
                            </>
                          </tbody>
                        </table>
                      )}
                    {typeofData == "State" &&
                      HeadcodeRole == "State-Deputy Secretary" && (
                        <table
                          className="m-0 p-0 ALlDistrictFinanceData Proposaloutward"
                          style={{ width: "100%", borderCollapse: "collapse" }}
                        >
                          <thead>
                            <tr
                              style={{
                                color: "white",
                                border: "none",
                                height: "3rem",
                                fontSize: "18px",
                              }}
                            >
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "60px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Sr.No")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "200px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Head Code")}
                              </th>{" "}
                              {/* changed from 9 to 7 */}
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "110px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Proposal Year")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "230px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Work Name")}
                              </th>
                              {userData?.RoleID !== 41 && (
                                <th
                                  style={{
                                    padding: "7px 10px",
                                    minWidth: "200px",
                                  }}
                                  rowSpan={2}
                                  colSpan={1}
                                >
                                  {t("Job ID")}
                                </th>
                              )}
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "120px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("District")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "120px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Taluka")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "200px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Gram Panchayat")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "150px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Constituency Name")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "150px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Proposal File Number")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "130px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Work Amount")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "130px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Class Of Work")}
                              </th>
                              {/* <th style={{ padding: "7px 10px", minWidth: "250px" }} rowSpan={2} colSpan={1}>{t("Proposal Copy")}</th> */}
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "250px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Additional Support Document")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "150px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Date")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "150px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Edited By")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "150px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("SendBack/Rejected")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "150px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Updated Field(if any)")}
                              </th>
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "150px",
                                }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Remark(if any)")}
                              </th>
                              {/* <th style={{ minWidth: "150px", padding: "8px" }}rowSpan={2} colSpan={1}>View Approvals</th> */}
                              <th style={{ padding: "7px 10px" }} colSpan={2}>
                                {t("Approved by")}
                              </th>{" "}
                              {/* changed from 9 to 7 */}
                            </tr>

                            <tr
                              style={{
                                width: "100%",
                                color: "white",
                                border: "none",
                                height: "3rem",
                                fontSize: "18px",
                                fontWeight: "400",
                              }}
                            >
                              <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "160px",
                                }}
                              >
                                {t("RDD Section Officer")}
                              </th>
                              {/* <th
                                style={{
                                  padding: "7px 10px",
                                  minWidth: "160px",
                                }}
                              >
                                {t("Deputy Secretary")}
                              </th> */}
                            </tr>
                          </thead>

                          <tbody>
                            <>
                              {displayedGRS?.length === 0 ? (
                                <tr>
                                  <td
                                    colSpan="30"
                                    style={{
                                      textAlign: "center",
                                      padding: "10px",
                                      backgroundColor: "#f9f9f9",
                                    }}
                                  >
                                    {t("No data available")}
                                  </td>
                                </tr>
                              ) : (
                                displayedGRS?.map((proposal, index) => {
                                  const bgColor =
                                    index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";

                                  return (
                                    <>
                                      <tr
                                        key={index}
                                        style={{
                                          backgroundColor: bgColor,
                                          fontSize: "18px",
                                          fontWeight: "400",
                                        }}
                                      >
                                        <td style={{ padding: "8px 8px" }}>
                                          {(currentPage - 1) * billsPerPage +
                                            index +
                                            1}
                                        </td>
                                        <td style={{ padding: "8px 8px" }}>
                                          {proposal.HeadCode}
                                        </td>
                                        <td style={{ padding: "8px 8px" }}>
                                          {proposal.Proposal_year}
                                        </td>
                                        <td style={{ padding: "8px 8px" }}>
                                          {proposal.Work_name}
                                        </td>
                                        {userData?.RoleID !== 41 && (
                                          <td style={{ padding: "8px 8px" }}>
                                            {proposal.JOB_ID}
                                          </td>
                                        )}
                                        <td style={{ padding: "8px 8px" }}>
                                          {proposal.District}
                                        </td>
                                        <td style={{ padding: "8px 8px" }}>
                                          {proposal.Taluka}
                                        </td>
                                        <td style={{ padding: "8px 8px" }}>
                                          {JSON.parse(
                                            proposal.Gram_panchayat,
                                          ).join(", ")}
                                        </td>
                                        <td style={{ padding: "8px 8px" }}>
                                          {proposal.Constituency_name}
                                        </td>
                                        <td style={{ padding: "8px 8px" }}>
                                          {proposal.Proposal_fileNumber}
                                        </td>
                                        <td style={{ padding: "8px 8px" }}>
                                          {/* {proposal.Proposal_amount} */}
                                          {Number(proposal.Proposal_amount || 0).toLocaleString("en-IN")}
                                        </td>
                                        <td style={{ padding: "8px 8px" }}>
                                          {proposal.classOfWork}
                                        </td>
                                        {/* <td style={{ padding: '8px 8px' }}>{
                                                                                    proposal.Proposal_copy ? (
                                                                                        <span
                                                                                            onClick={(e) => {
                                                                                                e.preventDefault();
                                                                                                SecureFileFetching(`ProposalFile/${proposal.Proposal_copy}`);
                                                                                            }}
                                                                                            // href={`${apiurl}/ProposalFile/${proposal.Proposal_copy}`}
                                                                                            className='text-primary'
                                                                                            style={{ cursor: "pointer" }}
                                                                                        >
                                                                                            {proposal.Proposal_copy}
                                                                                        </span>
                                                                                    )
                                                                                        :
                                                                                        (
                                                                                            <p className='fw-bold text-danger my-auto'>{t("No File")}</p>
                                                                                        )
                                                                                }
                                                                                </td> */}

                                        <td style={{ padding: "8px 8px" }}>
                                          {proposal.Proposal_copy ? (
                                            <span
                                              onClick={(e) => {
                                                e.preventDefault();
                                                SecureFileFetching(
                                                  `ProposalFile/${proposal.Proposal_copy}`,
                                                );
                                              }}
                                              // href={`${apiurl}/ProposalFile/${proposal.Proposal_copy}`}
                                              className="text-primary"
                                              style={{ cursor: "pointer" }}
                                            >
                                              {proposal.Proposal_copy}
                                            </span>
                                          ) : (
                                            <p className="fw-bold text-danger my-auto">
                                              {t("No File")}
                                            </p>
                                          )}
                                        </td>
                                        <td style={{ padding: "8px 8px" }}>
                                        {formatDateTime(
                                          proposal.created_at,
                                        )}
                                        </td>
                                        <td style={{ padding: "8px 8px" }}>
                                          {proposal.EditedBy ? (
                                            <p className="text-black my-auto fw-bold">
                                              {proposal.EditedBy}
                                            </p>
                                          ) : (
                                            <p className="text-danger my-auto fw-bold">
                                              {t("No One")}
                                            </p>
                                          )}
                                        </td>

                                        <td style={{ padding: "8px 8px" }}>
                                          {proposal.Status == "Pending"
                                            ? "-"
                                            : proposal.Status}
                                        </td>
                                        <td style={{ padding: "8px 8px" }}>
                                          {proposal.updatedFieldsStr || "NA"}
                                        </td>
                                        {/* <td style={{ padding: "8px 8px" }}>
                                          {proposal.Remark || "NA"}
                                        </td> */}
                                        <td
    className="py-2"
    style={{ padding: "12px 15px" }}
>
    {proposal.Remark?.trim() &&
     proposal.Remark.trim().toUpperCase() !== "NA"
        ? proposal.Remark
        : proposal.workRemark?.trim()
            ? proposal.workRemark
            : "N/A"}
</td>

                                        <td
                                          style={{
                                            padding: "8px",
                                            textAlign: "center",
                                          }}
                                        >
                                          {proposal.Approvance5 === "true" ? (
                                            <div
                                              className="m-auto"
                                              style={{
                                                width: "20px",
                                                height: "20px",
                                                borderRadius: "6px",
                                                backgroundColor: "#16C60C",
                                                border: "none",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                fontSize: "13px",
                                                color: "white",
                                                boxShadow:
                                                  "0 2px 4px rgba(0,0,0,0.1)",
                                              }}
                                            >
                                              ✓
                                            </div>
                                          ) : proposal.Approvance5 ===
                                            "false" ? (
                                            <div
                                              className="m-auto"
                                              style={{
                                                width: "20px",
                                                height: "20px",
                                                borderRadius: "6px",
                                                backgroundColor: "#dc2626",
                                                border: "none",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                fontSize: "13px",
                                                color: "white",
                                                boxShadow:
                                                  "0 2px 4px rgba(0,0,0,0.1)",
                                              }}
                                            >
                                              ✕
                                            </div>
                                          ) : (
                                            "-"
                                          )}
                                        </td>
                                        {/* <td
                                          style={{
                                            padding: "8px",
                                            textAlign: "center",
                                          }}
                                        >
                                          {proposal.Approvance6 === "true" ? (
                                            <div
                                              className="m-auto"
                                              style={{
                                                width: "20px",
                                                height: "20px",
                                                borderRadius: "6px",
                                                backgroundColor: "#16C60C",
                                                border: "none",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                fontSize: "13px",
                                                color: "white",
                                                boxShadow:
                                                  "0 2px 4px rgba(0,0,0,0.1)",
                                              }}
                                            >
                                              ✓
                                            </div>
                                          ) : proposal.Approvance6 ===
                                            "false" ? (
                                            <div
                                              className="m-auto"
                                              style={{
                                                width: "20px",
                                                height: "20px",
                                                borderRadius: "6px",
                                                backgroundColor: "#dc2626",
                                                border: "none",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                fontSize: "13px",
                                                color: "white",
                                                boxShadow:
                                                  "0 2px 4px rgba(0,0,0,0.1)",
                                              }}
                                            >
                                              ✕
                                            </div>
                                          ) : (
                                            "-"
                                          )}
                                        </td> */}
                                      </tr>
                                    </>
                                  );
                                })
                              )}
                              <tr
                                style={{
                                  fontWeight: "600",
                                  backgroundColor: "#f0f0f0",
                                  fontSize: "18px",
                                }}
                              >
                                <td colSpan={typeofData == "District" &&
                                  (HeadcodeRole !== "State-Deputy Secretary" && [24, 25, 32, 33,40,41].includes(RoleID)) ? 9 : 10} style={{ textAlign: "right", padding: "8px" }}>
                                  {t("Page Total")}
                                </td>

                                <td style={{ padding: "8px" }}  >
                                  ₹ {pageProposalAmount.toLocaleString("en-IN")}
                                </td>

                                {/* remaining columns */}
                                <td colSpan={typeofData == "District" &&
                                  (HeadcodeRole !== "State-Deputy Secretary" && [24, 25, 32, 33,40,41].includes(RoleID)) ? 19 : 20}></td>
                              </tr>
                              <tr
                                style={{
                                  fontWeight: "600",
                                  backgroundColor: "#f0f0f0",
                                  fontSize: "18px",

                                }}
                              >
                                <td colSpan={typeofData == "District" &&
                                  (HeadcodeRole !== "State-Deputy Secretary" && [24, 25, 32, 33,40,41].includes(RoleID)) ? 9 : 10} style={{ textAlign: "right", padding: "8px" }}>
                                  {t("Gross Total")}
                                </td>

                                <td style={{ padding: "8px" }}  >
                                  ₹ {totalProposalAmount.toLocaleString("en-IN")}
                                </td>

                                {/* remaining columns */}
                                <td colSpan={typeofData == "District" &&
                                  (HeadcodeRole !== "State-Deputy Secretary" && [24, 25, 32, 33,40,41].includes(RoleID)) ? 19 : 20}></td>
                              </tr>
                            </>
                          </tbody>
                        </table>
                      )}
                  </div>

                  <div className="col-12 mt-4 mb-2">
                    <div className="row">
                      <div className="col-6">
                        <p
                          className="text-gray-600"
                          style={{ fontSize: "18px", margin: 0 }}
                        >
                          {t("Showing")} {indexOfFirstBill + 1} {t("to")}{" "}
                          {Math.min(indexOfLastBill, filteredBills.length)}{" "}
                          {t("of")} {filteredBills?.length} {t("entries")}
                        </p>
                      </div>
                      <div
                        className="col-6"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "end",
                        }}
                      >
                        <GooglePagination
                          currentPage={currentPage}
                          totalPages={totalPages}
                          onPageChange={setCurrentPage}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div></div>

        {selectedProposal && (
          <div
            onClick={() => setSelectedProposal(null)}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.84)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
            }}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              style={{
                backgroundColor: "white",
                padding: "40px 40px",
                borderRadius: "20px",
                width: "50%",
                maxHeight: "90vh",
                overflow: "hidden",
                boxShadow: "0 2px 10px rgba(0,0,0,0.3)",
                position: "relative",
              }}
            >
              <div className="col-12">
                <div className="col-12  mb-3">
                  <div className="row">
                    <div className="col-6">
                      <h5 className="fw-bold">
                        {t("Proposal Approval Detail")}
                      </h5>
                    </div>

                    <div
                      className="col-6"
                      style={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <button
                        onClick={() => setSelectedProposal(null)}
                        style={{
                          width: "32px",
                          height: "32px",
                          borderRadius: "50%",
                          backgroundColor: "red",
                          border: "none",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          cursor: "pointer",
                          fontSize: "24px",
                          fontWeight: "bold",
                          color: "white",
                          lineHeight: 1,
                        }}
                      >
                        ×
                      </button>
                    </div>
                  </div>
                </div>

                <div
                  className="col-12"
                  style={{
                    height: "59vh",
                    overflowX: "hidden",
                    overflowY: "scroll",
                    scrollBehavior: "smooth",
                  }}
                >
                  {false && (
                    <table className="m-0 p-0" style={{ width: "100%" }}>
                      <thead>
                        <tr
                          style={{
                            color: "white",
                            border: "none",
                            height: "3.5rem",
                            fontSize: "18px",
                            fontWeight: "400",
                          }}
                        >
                          <th
                            style={{ width: "15%", border: "1px solid white" }}
                            rowSpan={2}
                            colSpan={1}
                          >
                            {t("Proposal Name")}
                          </th>
                          <th
                            style={{ width: "77%", border: "1px solid white" }}
                            colSpan={6}
                          >
                            {t("Approved by")}
                          </th>{" "}
                          {/* changed from 9 to 7 */}
                          <th
                            style={{
                              width: "8%",
                              textAlign: "center",
                              border: "1px solid white",
                            }}
                            colSpan={1}
                            rowSpan={2}
                          >
                            {t("Details")}
                          </th>
                        </tr>
                        <tr
                          style={{
                            width: "100%",
                            color: "white",
                            border: "none",
                            height: "3rem",
                          }}
                        >
                          <th
                            style={{ width: "12%", border: "1px solid white" }}
                          >
                            {t("Deputy Engineer")}
                          </th>
                          <th
                            style={{ width: "14%", border: "1px solid white" }}
                          >
                            {t("Department HOD(EE)")}
                          </th>
                          <th
                            style={{ width: "12%", border: "1px solid white" }}
                          >
                            {t("Additional CEO")}
                          </th>
                          <th
                            style={{ width: "13%", border: "1px solid white" }}
                          >
                            {t("RDD Checker (ASO)")}
                          </th>
                          <th
                            style={{ width: "13%", border: "1px solid white" }}
                          >
                            {t("RDD Section Officer")}
                          </th>
                          {/* <th
                            style={{ width: "13%", border: "1px solid white" }}
                          >
                            {t("Deputy Secretary")}
                          </th> */}
                        </tr>
                      </thead>

                      <tbody>
                        {currentBills?.length === 0 ? (
                          <tr>
                            <td
                              colSpan="10"
                              style={{
                                textAlign: "center",
                                padding: "20px",
                                backgroundColor: "#f9f9f9",
                              }}
                            >
                              {t("No data available")}
                            </td>
                          </tr>
                        ) : (
                          currentBills?.map((proposal, index) => {
                            const bgColor =
                              index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                            return (
                              <tr
                                style={{ backgroundColor: bgColor }}
                                key={proposal.DemandGenerationID || index}
                              >
                                <td
                                  className="fw-bold"
                                  style={{ fontSize: "18px", padding: "5px" }}
                                >
                                  {proposal.Work_name}
                                </td>
                                <td
                                  style={{
                                    padding: "8px",
                                    textAlign: "center",
                                  }}
                                >
                                  {proposal.Approvance1 === "true" ? (
                                    <div
                                      className="m-auto"
                                      style={{
                                        width: "20px",
                                        height: "20px",
                                        borderRadius: "6px",
                                        backgroundColor: "#16C60C",
                                        border: "none",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        fontSize: "13px",
                                        color: "white",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                      }}
                                    >
                                      ✓
                                    </div>
                                  ) : proposal.Approvance1 === "false" ? (
                                    <div
                                      className="m-auto"
                                      style={{
                                        width: "20px",
                                        height: "20px",
                                        borderRadius: "6px",
                                        backgroundColor: "#dc2626",
                                        border: "none",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        fontSize: "13px",
                                        color: "white",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                      }}
                                    >
                                      ✕
                                    </div>
                                  ) : (
                                    "-"
                                  )}
                                </td>
                                <td
                                  style={{
                                    padding: "8px",
                                    textAlign: "center",
                                  }}
                                >
                                  {proposal.Approvance2 === "true" ? (
                                    <div
                                      className="m-auto"
                                      style={{
                                        width: "20px",
                                        height: "20px",
                                        borderRadius: "6px",
                                        backgroundColor: "#16C60C",
                                        border: "none",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        fontSize: "13px",
                                        color: "white",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                      }}
                                    >
                                      ✓
                                    </div>
                                  ) : proposal.Approvance2 === "false" ? (
                                    <div
                                      className="m-auto"
                                      style={{
                                        width: "20px",
                                        height: "20px",
                                        borderRadius: "6px",
                                        backgroundColor: "#dc2626",
                                        border: "none",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        fontSize: "13px",
                                        color: "white",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                      }}
                                    >
                                      ✕
                                    </div>
                                  ) : (
                                    "-"
                                  )}
                                </td>
                                <td
                                  style={{
                                    padding: "8px",
                                    textAlign: "center",
                                  }}
                                >
                                  {proposal.Approvance3 === "true" ? (
                                    <div
                                      className="m-auto"
                                      style={{
                                        width: "20px",
                                        height: "20px",
                                        borderRadius: "6px",
                                        backgroundColor: "#16C60C",
                                        border: "none",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        fontSize: "13px",
                                        color: "white",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                      }}
                                    >
                                      ✓
                                    </div>
                                  ) : proposal.Approvance3 === "false" ? (
                                    <div
                                      className="m-auto"
                                      style={{
                                        width: "20px",
                                        height: "20px",
                                        borderRadius: "6px",
                                        backgroundColor: "#dc2626",
                                        border: "none",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        fontSize: "13px",
                                        color: "white",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                      }}
                                    >
                                      ✕
                                    </div>
                                  ) : (
                                    "-"
                                  )}
                                </td>
                                <td
                                  style={{
                                    padding: "8px",
                                    textAlign: "center",
                                  }}
                                >
                                  {proposal.Approvance4 === "true" ? (
                                    <div
                                      className="m-auto"
                                      style={{
                                        width: "20px",
                                        height: "20px",
                                        borderRadius: "6px",
                                        backgroundColor: "#16C60C",
                                        border: "none",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        fontSize: "13px",
                                        color: "white",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                      }}
                                    >
                                      ✓
                                    </div>
                                  ) : proposal.Approvance4 === "false" ? (
                                    <div
                                      className="m-auto"
                                      style={{
                                        width: "20px",
                                        height: "20px",
                                        borderRadius: "6px",
                                        backgroundColor: "#dc2626",
                                        border: "none",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        fontSize: "13px",
                                        color: "white",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                      }}
                                    >
                                      ✕
                                    </div>
                                  ) : (
                                    "-"
                                  )}
                                </td>
                                <td
                                  style={{
                                    padding: "8px",
                                    textAlign: "center",
                                  }}
                                >
                                  {proposal.Approvance5 === "true" ? (
                                    <div
                                      className="m-auto"
                                      style={{
                                        width: "20px",
                                        height: "20px",
                                        borderRadius: "6px",
                                        backgroundColor: "#16C60C",
                                        border: "none",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        fontSize: "13px",
                                        color: "white",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                      }}
                                    >
                                      ✓
                                    </div>
                                  ) : proposal.Approvance5 === "false" ? (
                                    <div
                                      className="m-auto"
                                      style={{
                                        width: "20px",
                                        height: "20px",
                                        borderRadius: "6px",
                                        backgroundColor: "#dc2626",
                                        border: "none",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        fontSize: "13px",
                                        color: "white",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                      }}
                                    >
                                      ✕
                                    </div>
                                  ) : (
                                    "-"
                                  )}
                                </td>
                                {/* <td
                                  style={{
                                    padding: "8px",
                                    textAlign: "center",
                                  }}
                                >
                                  {proposal.Approvance6 === "true" ? (
                                    <div
                                      className="m-auto"
                                      style={{
                                        width: "20px",
                                        height: "20px",
                                        borderRadius: "6px",
                                        backgroundColor: "#16C60C",
                                        border: "none",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        fontSize: "13px",
                                        color: "white",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                      }}
                                    >
                                      ✓
                                    </div>
                                  ) : proposal.Approvance6 === "false" ? (
                                    <div
                                      className="m-auto"
                                      style={{
                                        width: "20px",
                                        height: "20px",
                                        borderRadius: "6px",
                                        backgroundColor: "#dc2626",
                                        border: "none",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        fontSize: "13px",
                                        color: "white",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                      }}
                                    >
                                      ✕
                                    </div>
                                  ) : (
                                    "-"
                                  )}
                                </td> */}
                                {/* <td style={{ padding: '8px' }}>{proposal.Proposal_copy}</td> */}
                                <td>
                                  <button
                                    className="m-auto"
                                    onClick={() =>
                                      selectedBillDetails(proposal.ProposalID)
                                    }
                                    style={{
                                      cursor: "pointer",
                                      background:
                                        "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                                      color: "white",
                                      border: "none",
                                      padding: "6px 20px",
                                      borderRadius: "4px",
                                      fontSize: "18px",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      width: "80%",
                                    }}
                                  >
                                    <img
                                      src="/view32.png"
                                      alt="view"
                                      className="me-1"
                                      style={{ width: "12px", height: "12px" }}
                                    />
                                    {t("View")}
                                  </button>
                                </td>
                              </tr>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                  )}

                  <table
                    style={{
                      width: "100%",
                      height: "100%",
                      borderCollapse: "collapse",
                    }}
                  >
                    <tbody>
                      {Object.entries(selectedProposal).map(
                        ([key, value], index) => (
                          <>
                            <tr
                              key={key}
                              style={{
                                backgroundColor: "#cce0f9",
                                border: "1px solid #2B75D5",
                              }}
                            >
                              <td
                                style={{
                                  fontWeight: "bold",
                                  padding: "8px",
                                  width: "40%",
                                  backgroundColor: "#2B75D5",
                                  color: "white",
                                  border: "1px solid #cce0f9",
                                }}
                              >
                                {key}
                              </td>

                              <td
                                style={{
                                  padding: "8px",
                                  textAlign: "center",
                                  border: "1px solid #a1a1a1ff",
                                }}
                              >
                                {value === "true" ? (
                                  <div
                                    className="m-auto"
                                    style={{
                                      width: "20px",
                                      height: "20px",
                                      borderRadius: "6px",
                                      backgroundColor: "#16C60C",
                                      border: "none",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      fontSize: "13px",
                                      color: "white",
                                      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                    }}
                                  >
                                    ✓
                                  </div>
                                ) : value === "false" ? (
                                  <div
                                    className="m-auto"
                                    style={{
                                      width: "20px",
                                      height: "20px",
                                      borderRadius: "6px",
                                      backgroundColor: "#dc2626",
                                      border: "none",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      fontSize: "13px",
                                      color: "white",
                                      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                    }}
                                  >
                                    ✕
                                  </div>
                                ) : (
                                  "-"
                                )}
                              </td>
                            </tr>
                          </>
                        ),
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        )}

        {loading && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(255,255,255,0.4)",
              backdropFilter: "blur(2px)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
            }}
          >
            <div className="Adminloader"></div>
          </div>
        )}
      </div>
    </>
  );
};

export default CreateOutwards;
